<template>
    <div class="app-content content">
        <div class="content-wrapper">
            <div class="content-wrapper-before"></div>

            <div
                class="content-body add-content-body order-details order_details_vtwo"
            >
                <section class="row order-details-section" v-if="order_detail">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-content">
                                <div class="card-body product_card p-0">
                                    <div
                                        class="product_information product_information_main_box_custom"
                                    >
                                        <div
                                            class="accordian_detals contact_detail_wrap account_detail_left_rt"
                                        >
                                            <div class="acc">
                                                <div class="acc__card">
                                                    <div
                                                        class="acc__title acc_head d-none"
                                                    >
                                                        &nbsp;
                                                    </div>
                                                    <div
                                                        class="acc__panel order-list-page"
                                                    >
                                                        <!-- heading end -->
                                                        <div
                                                            class="row base_pro_row_custom m-0"
                                                            v-for="(
                                                                item, index
                                                            ) in order_detail.items ||
                                                            []"
                                                            :key="index"
                                                        >
                                                            <div
                                                                class="col-md-8 order-list-col"
                                                            >
                                                                <div class="p_border">
                                                                    <div class="d-flex base_product_box_custom product_details_box">
                                                                        <!-- LEFT GROUP: image + product text side by side (same as admin inner d-flex) -->
                                                                        <div class="d-flex">
                                                                            <div class="align-self-start">
                                                                                <div class="product-box">
                                                                                    <img
                                                                                        v-if="item.design_image"
                                                                                        :src="item.design_image ? item.design_image.split(',')[0] : item.design_image"
                                                                                        class="img-fluid"
                                                                                    />
                                                                                    <img
                                                                                        v-else-if="item.product_image"
                                                                                        :src="item.product_image.url"
                                                                                        class="img-fluid"
                                                                                    />
                                                                                    <a
                                                                                        href="#"
                                                                                        class="hover_search"
                                                                                        data-toggle="modal"
                                                                                        :data-target="'#imagepreview-' + index"
                                                                                    >
                                                                                        <img src="/images/zoom.svg" />
                                                                                    </a>
                                                                                </div>
                                                                                <span class="product_number">{{ item.product_number }}</span>
                                                                            </div>

                                                                            <!-- Product text: inside inner d-flex, right of image -->
                                                                            <div class="align-self-start base_product_text_box_custom">
                                                                                <div class="color-line vendor_name" v-if="item.Vendor && item.Vendor.name">
                                                                                    <span>Vendor:</span> {{ item.Vendor.name }}
                                                                                </div>
                                                                                <div class="product_name_main">{{ item.name }}</div>
                                                                                <div class="color-line order-item-size-pricing">
                                                                                    <div
                                                                                        v-for="(row, sIdx) in getOrderItemSizePriceRows(item)"
                                                                                        :key="sIdx"
                                                                                        class="order-item-size-pricing__line"
                                                                                    >
                                                                                        {{ row.label }}:{{ row.qty }} @ {{ icPriceFormat(row.unit) }} = {{ icPriceFormat(row.lineTotal) }}
                                                                                    </div>
                                                                                </div>
                                                                                <div class="product_details">
                                                                                    <div class="color-line mt_8 d-flex align-items-center" v-if="item.color">
                                                                                        <img
                                                                                            v-if="item.color.swatches"
                                                                                            class="small_color_box"
                                                                                            :src="item.color.swatches"
                                                                                            v-tooltip="{ content: item.color.name, autoHide: false }"
                                                                                            alt=""
                                                                                        />
                                                                                        <span
                                                                                            v-else
                                                                                            :title="item.color.name"
                                                                                            class="small_color_box"
                                                                                            :style="'background: ' + item.color.hex + ';'"
                                                                                        ></span>
                                                                                    </div>
                                                                                    <div v-if="item.total_quantity" class="order-item-total-qty">
                                                                                        Total Qty : <span class="font-weight-bold">{{ item.total_quantity }}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <!-- END LEFT GROUP -->

                                                                        <!-- RIGHT: decorator logo + service — 2nd flex child, pushed right by space-between -->
                                                                        <div class="imprint-loc-extra-meta align-self-start">
                                                                            <div
                                                                                v-if="getDecoratorLogo(item)"
                                                                                class="imprint-loc-decorator-logo text-center mb-1"
                                                                            >
                                                                                <img
                                                                                    :src="getDecoratorLogo(item)"
                                                                                    alt="Brand logo"
                                                                                    class="brand-logo-img"
                                                                                />
                                                                            </div>
                                                                            <div class="pr-2">
                                                                                <div>Decoration Service: {{ getDecorationServiceName(item) }}</div>
                                                                                <div v-if="getEstimatedShippingDate(item)" class="imprint-loc-shipdate">
                                                                                    Est. Ship Date: {{ formatEstimatedShippingDate(getEstimatedShippingDate(item)) }}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <!-- Name/Number table + Export -->
                                                                <NameNumberTable
                                                                    :rows="item.name_and_number_json_table || []"
                                                                    :show-export="true"
                                                                    csv-file-name="NameAndNumber.csv"
                                                                    :csv-header="'Name,Number,Size\\n'"
                                                                />

                                                                <!-- Imprint locations (F/B/L/R thumbnails) -->
                                                                <div class="p_border decoration_main_box imprint-locations-wrapper">
                                                                    <ImprintLocationsRow
                                                                        :locations="getImprintLocations(item)"
                                                                        :modal-target="`#canvas-images-model-${index}`"
                                                                        @open-modal="onImprintOpenCanvasModal(index, $event)"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <!-- IMAGE PREVIEW MODEL -->
                                                            <div
                                                                class="modal fade cart_preview"
                                                                :id="
                                                                    'imagepreview-' +
                                                                    index
                                                                "
                                                                data-backdrop="static"
                                                                data-keyboard="false"
                                                                tabindex="-1"
                                                                aria-labelledby="staticBackdropLabel"
                                                                aria-hidden="true"
                                                            >
                                                                <div
                                                                    class="modal-dialog modal-dialog-centered cart_modal_s"
                                                                    style="
                                                                        max-width: 823px;
                                                                        width: 100%;
                                                                    "
                                                                >
                                                                    <div
                                                                        class="modal-content"
                                                                    >
                                                                        <div
                                                                            class="modal-header border-bottom-0"
                                                                        >
                                                                            <div
                                                                                class="order-number"
                                                                            >
                                                                                <h3>
                                                                                    Order
                                                                                    Number-:
                                                                                    <span
                                                                                        ><b
                                                                                            >#{{
                                                                                                order_detail.unique_order_id
                                                                                            }}</b
                                                                                        ></span
                                                                                    >
                                                                                </h3>
                                                                            </div>
                                                                            <button
                                                                                type="button"
                                                                                class="close"
                                                                                data-dismiss="modal"
                                                                                aria-label="Close"
                                                                            >
                                                                                <img
                                                                                    src="/images/close_popup.svg"
                                                                                    alt=" "
                                                                                />
                                                                            </button>
                                                                        </div>

                                                                        <div
                                                                            v-if="
                                                                                item.design_images &&
                                                                                item
                                                                                    .design_images
                                                                                    .length >
                                                                                    0
                                                                            "
                                                                            class="modal-body pt-0"
                                                                        >
                                                                            <div
                                                                                :class="
                                                                                    'canvas_auto_preview_images ' +
                                                                                    (item.design_images &&
                                                                                    safeParseJSON(
                                                                                        item.design_images
                                                                                    ) &&
                                                                                    safeParseJSON(
                                                                                        item.design_images
                                                                                    )
                                                                                        .length >
                                                                                        0
                                                                                        ? 'new_canvas_images' +
                                                                                          safeParseJSON(
                                                                                              item.design_images
                                                                                          )
                                                                                              .length
                                                                                        : '')
                                                                                "
                                                                                style="
                                                                                    display: flex;
                                                                                    margin-top: 20px;
                                                                                "
                                                                            >
                                                                                <div
                                                                                    class="mx-auto preview-image"
                                                                                    v-for="(
                                                                                        design_img,
                                                                                        index
                                                                                    ) in safeParseJSON(
                                                                                        item.design_images
                                                                                    ) ||
                                                                                    []"
                                                                                    :key="
                                                                                        index
                                                                                    "
                                                                                >
                                                                                    <h4>
                                                                                        {{
                                                                                            design_img.label.replace(
                                                                                                /(?:^|\s|-)\S/g,
                                                                                                (
                                                                                                    x
                                                                                                ) =>
                                                                                                    x.toUpperCase()
                                                                                            )
                                                                                        }}
                                                                                    </h4>
                                                                                    <div
                                                                                        class="product-box text-center"
                                                                                    >
                                                                                        <img
                                                                                            v-if="
                                                                                                design_img
                                                                                            "
                                                                                            :src="
                                                                                                design_img
                                                                                                    ? design_img.url
                                                                                                    : design_img
                                                                                            "
                                                                                            :style="
                                                                                                'background-color:' +
                                                                                                item
                                                                                                    .color
                                                                                                    .hex +
                                                                                                ';'
                                                                                            "
                                                                                            class="img-fluid"
                                                                                        />
                                                                                        <img
                                                                                            v-else-if="
                                                                                                item.product_image
                                                                                            "
                                                                                            :src="
                                                                                                item
                                                                                                    .product_image
                                                                                                    .url
                                                                                            "
                                                                                            class="img-fluid"
                                                                                        />
                                                                                    </div>
                                                                                    <div
                                                                                        v-if="
                                                                                            item.design_area_inches &&
                                                                                            safeParseJSON(
                                                                                                item.design_area_inches
                                                                                            ) &&
                                                                                            safeParseJSON(
                                                                                                item.design_area_inches
                                                                                            )
                                                                                                .length >
                                                                                                0
                                                                                        "
                                                                                    >
                                                                                        <template
                                                                                            v-for="(
                                                                                                design_inches,
                                                                                                design_inch_index
                                                                                            ) in safeParseJSON(
                                                                                                item.design_area_inches
                                                                                            ) ||
                                                                                            []"
                                                                                        >
                                                                                            <h4
                                                                                                class="dimension_text"
                                                                                                :key="
                                                                                                    design_inch_index
                                                                                                "
                                                                                                v-if="
                                                                                                    matchDimensionLabel(design_img.label, design_inches) &&
                                                                                                    hasDimensionInches(design_inches)
                                                                                                "
                                                                                            >
                                                                                                Imprint Area {{ getDimensionWidth(design_inches) }}<span>&#8243;</span> <b>&#215;</b> {{ getDimensionHeight(design_inches) }}<span>&#8243;</span>
                                                                                            </h4>
                                                                                        </template>
                                                                                    </div>
                                                                                    <div
                                                                                        class="product_details mb-2"
                                                                                        v-if="hasNameNumberForView(item, design_img.label || design_img.view || design_img.location)"
                                                                                    >
                                                                                        <p class="mb-0">Name Color: <span><b>{{ hasNameForView(item, design_img.label || design_img.view || design_img.location) ? (getNameNumberColor(item, 'nameColor', normalizeLocationForNameNumber(design_img.label || design_img.view || design_img.location)) || '—') : '—' }}</b></span> | Number Color: <span><b>{{ hasNumberForView(item, design_img.label || design_img.view || design_img.location) ? (getNameNumberColor(item, 'numberColor', normalizeLocationForNameNumber(design_img.label || design_img.view || design_img.location)) || '—') : '—' }}</b></span></p>
                                                                                        <p class="mb-0">Name Size: <span><b>{{ hasNameForView(item, design_img.label || design_img.view || design_img.location) ? (getNameNumberSize(item, 'nameSize', normalizeLocationForNameNumber(design_img.label || design_img.view || design_img.location)) || '—') : '—' }}</b></span> | Number Size: <span><b>{{ hasNumberForView(item, design_img.label || design_img.view || design_img.location) ? (getNameNumberSize(item, 'numberSize', normalizeLocationForNameNumber(design_img.label || design_img.view || design_img.location)) || '—') : '—' }}</b></span></p>
                                                                                        <p class="mb-0">Name Font: <span><b>{{ hasNameForView(item, design_img.label || design_img.view || design_img.location) ? (getNameNumberFont(item, 'nameFont', normalizeLocationForNameNumber(design_img.label || design_img.view || design_img.location)) || '—') : '—' }}</b></span> | Number Font: <span><b>{{ hasNumberForView(item, design_img.label || design_img.view || design_img.location) ? (getNameNumberFont(item, 'numberFont', normalizeLocationForNameNumber(design_img.label || design_img.view || design_img.location)) || '—') : '—' }}</b></span></p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div
                                                                            v-else
                                                                            class="modal-body pt-0"
                                                                        >
                                                                            <div
                                                                                class="canvas_auto_preview_images new_canvas_images1"
                                                                                style="
                                                                                    display: flex;
                                                                                    margin-top: 20px;
                                                                                "
                                                                            >
                                                                                <div
                                                                                    class="mx-auto preview-image"
                                                                                    style="
                                                                                        padding-left: 10px;
                                                                                    "
                                                                                >
                                                                                    <div
                                                                                        class="product-box"
                                                                                    >
                                                                                        <img
                                                                                            v-if="
                                                                                                item.design_image
                                                                                            "
                                                                                            :src="
                                                                                                item.design_image
                                                                                                    ? item.design_image.split(
                                                                                                          ','
                                                                                                      )[0]
                                                                                                    : item.design_image
                                                                                            "
                                                                                            class="img-fluid"
                                                                                        />
                                                                                        <img
                                                                                            v-else-if="
                                                                                                item.product_image
                                                                                            "
                                                                                            :src="
                                                                                                item
                                                                                                    .product_image
                                                                                                    .url
                                                                                            "
                                                                                            class="img-fluid"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <!-- Artwork preview modal (same as Items by Address – name/number support) -->
                                                            <ArtworkPreviewModal
                                                                :modal-id="'canvas-images-model-' + index"
                                                                :design-images="getDesignImagesForCanvasModal(item, index) || []"
                                                                :on-close="() => onCloseCanvasModal(index)"
                                                            />

                                                            <div
                                                                class="col-md-4 order-list-col-sec-last pl-0 pr-0"
                                                            >
                                                                <div
                                                                    class="p_border border-right-0"
                                                                >
                                                                    <div
                                                                        class="product_details"
                                                                    >
                                                                        <!-- Base Fee -->
                                                                        <div
                                                                            class="row color-line"
                                                                            v-if="
                                                                                getBaseFeeTotal(
                                                                                    item
                                                                                ) >
                                                                                    0 ||
                                                                                (getBreakdownData(
                                                                                    item,
                                                                                    'base_fee'
                                                                                ) &&
                                                                                    getBreakdownData(
                                                                                        item,
                                                                                        'base_fee'
                                                                                    )
                                                                                        .length >
                                                                                        0)
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="col-md-6"
                                                                            >
                                                                                <div
                                                                                    class="d-flex align-items-center base_product_box_custom"
                                                                                >
                                                                                    <div>
                                                                                        {{
                                                                                            getRollupFeeDisplayName(
                                                                                                1
                                                                                            ) ||
                                                                                            "Base Fee"
                                                                                        }}
                                                                                    </div>
                                                                                    <div
                                                                                        class="tooltip-wrapper"
                                                                                        v-if="
                                                                                            getBaseFeeTotal(
                                                                                                item
                                                                                            ) >
                                                                                                0 &&
                                                                                            getBreakdownData(
                                                                                                item,
                                                                                                'base_fee'
                                                                                            ) &&
                                                                                            getBreakdownData(
                                                                                                item,
                                                                                                'base_fee'
                                                                                            )
                                                                                                .length >
                                                                                                0
                                                                                        "
                                                                                        @click.stop="
                                                                                            toggleCostTooltip(
                                                                                                index,
                                                                                                'baseFee'
                                                                                            )
                                                                                        "
                                                                                    >
                                                                                        <svg
                                                                                            class="ml_6 info-icon-svg"
                                                                                            width="16"
                                                                                            height="16"
                                                                                            viewBox="0 0 16 16"
                                                                                            fill="none"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                            aria-hidden="true"
                                                                                            focusable="false"
                                                                                        >
                                                                                            <path d="M8.0026 14.6654C11.6693 14.6654 14.6693 11.6654 14.6693 7.9987C14.6693 4.33203 11.6693 1.33203 8.0026 1.33203C4.33594 1.33203 1.33594 4.33203 1.33594 7.9987C1.33594 11.6654 4.33594 14.6654 8.0026 14.6654Z" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                            <path d="M8 5.33203V8.66536" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                            <path d="M8 10.668H8.00599" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                        </svg>
                                                                                        <div
                                                                                            v-if="
                                                                                                costTooltipVisible ===
                                                                                                `${index}-baseFee`
                                                                                            "
                                                                                            class="tooltip-content is-visible"
                                                                                        >
                                                                                            <div
                                                                                                class="tooltip-header"
                                                                                            >
                                                                                                <h4>
                                                                                                    {{
                                                                                                        getRollupFeeDisplayName(
                                                                                                            1
                                                                                                        ) ||
                                                                                                        "Base Fee"
                                                                                                    }}
                                                                                                    Breakdown
                                                                                                </h4>
                                                                                                <svg
                                                                                                    class="close-icon"
                                                                                                    @click.stop="
                                                                                                        closeCostTooltip(
                                                                                                            index
                                                                                                        )
                                                                                                    "
                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                    viewBox="0 0 24 24"
                                                                                                    fill="none"
                                                                                                    stroke="currentColor"
                                                                                                    stroke-width="2"
                                                                                                    stroke-linecap="round"
                                                                                                    stroke-linejoin="round"
                                                                                                >
                                                                                                    <line
                                                                                                        x1="18"
                                                                                                        y1="6"
                                                                                                        x2="6"
                                                                                                        y2="18"
                                                                                                    ></line>
                                                                                                    <line
                                                                                                        x1="6"
                                                                                                        y1="6"
                                                                                                        x2="18"
                                                                                                        y2="18"
                                                                                                    ></line>
                                                                                                </svg>
                                                                                            </div>
                                                                                            <div
                                                                                                class="tooltip-body"
                                                                                            >
                                                                                                <table
                                                                                                    class="base-fee-table"
                                                                                                >
                                                                                                    <thead>
                                                                                                        <tr>
                                                                                                            <th>
                                                                                                                Fee
                                                                                                            </th>
                                                                                                            <th>
                                                                                                                Color
                                                                                                            </th>
                                                                                                            <th>
                                                                                                                Qty
                                                                                                            </th>
                                                                                                            <th>
                                                                                                                Amt
                                                                                                            </th>
                                                                                                            <th>
                                                                                                                Total
                                                                                                            </th>
                                                                                                        </tr>
                                                                                                    </thead>
                                                                                                    <tbody>
                                                                                                        <tr
                                                                                                            v-for="(
                                                                                                                fee,
                                                                                                                fee_index
                                                                                                            ) in getBreakdownData(
                                                                                                                item,
                                                                                                                'base_fee'
                                                                                                            )"
                                                                                                            :key="
                                                                                                                fee_index
                                                                                                            "
                                                                                                        >
                                                                                                            <td>
                                                                                                                {{
                                                                                                                    fee.type ===
                                                                                                                        "service" &&
                                                                                                                    fee.ecomm_display
                                                                                                                        ? fee.ecomm_display
                                                                                                                        : fee.name ||
                                                                                                                          "Fee"
                                                                                                                }}
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                <div
                                                                                                                    class="color-box-wrapper"
                                                                                                                    v-if="
                                                                                                                        fee.type !==
                                                                                                                            'service' &&
                                                                                                                        item.color
                                                                                                                    "
                                                                                                                >
                                                                                                                    <img
                                                                                                                        v-if="
                                                                                                                            item
                                                                                                                                .color
                                                                                                                                .swatches
                                                                                                                        "
                                                                                                                        class="color-box color-box-img"
                                                                                                                        :src="
                                                                                                                            item
                                                                                                                                .color
                                                                                                                                .swatches
                                                                                                                        "
                                                                                                                        :title="
                                                                                                                            item
                                                                                                                                .color
                                                                                                                                .name ||
                                                                                                                            ''
                                                                                                                        "
                                                                                                                        alt=""
                                                                                                                    />
                                                                                                                    <div
                                                                                                                        v-else
                                                                                                                        class="color-box"
                                                                                                                        :style="
                                                                                                                            'background: ' +
                                                                                                                            (item
                                                                                                                                .color
                                                                                                                                .hex ||
                                                                                                                                '#ccc') +
                                                                                                                            ';'
                                                                                                                        "
                                                                                                                        :title="
                                                                                                                            item
                                                                                                                                .color
                                                                                                                                .name ||
                                                                                                                            ''
                                                                                                                        "
                                                                                                                    ></div>
                                                                                                                </div>
                                                                                                                <span
                                                                                                                    v-else
                                                                                                                    >-</span
                                                                                                                >
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                {{
                                                                                                                    fee.qty ||
                                                                                                                    "-"
                                                                                                                }}
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                {{
                                                                                                                    fee.amt ===
                                                                                                                        "INCL" ||
                                                                                                                    fee.amt ===
                                                                                                                        "-"
                                                                                                                        ? fee.amt
                                                                                                                        : fee.amt
                                                                                                                        ? icPriceFormat(
                                                                                                                              parseFloat(
                                                                                                                                  fee.amt ||
                                                                                                                                      0
                                                                                                                              )
                                                                                                                          )
                                                                                                                        : "-"
                                                                                                                }}
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                {{
                                                                                                                    fee.total ===
                                                                                                                        "INCL" ||
                                                                                                                    fee.total ===
                                                                                                                        "-"
                                                                                                                        ? fee.total
                                                                                                                        : fee.total
                                                                                                                        ? icPriceFormat(
                                                                                                                              parseFloat(
                                                                                                                                  fee.total ||
                                                                                                                                      0
                                                                                                                              )
                                                                                                                          )
                                                                                                                        : "-"
                                                                                                                }}
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                        <tr
                                                                                                            v-if="
                                                                                                                getBaseFeeTotal(
                                                                                                                    item
                                                                                                                ) >
                                                                                                                0
                                                                                                            "
                                                                                                            class="total-row"
                                                                                                        >
                                                                                                            <td
                                                                                                                class="text_left"
                                                                                                                colspan="4"
                                                                                                            >
                                                                                                                <strong
                                                                                                                    >Total</strong
                                                                                                                >
                                                                                                            </td>
                                                                                                            <td
                                                                                                                class="text_right"
                                                                                                            >
                                                                                                                <strong
                                                                                                                    >{{
                                                                                                                        icPriceFormat(
                                                                                                                            getBaseFeeTotal(
                                                                                                                                item
                                                                                                                            )
                                                                                                                        )
                                                                                                                    }}</strong
                                                                                                                >
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    </tbody>
                                                                                                </table>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                class="col-md-5"
                                                                            >
                                                                                <span
                                                                                    class="price_right"
                                                                                    >{{
                                                                                        icPriceFormat(
                                                                                            getBaseFeeTotal(
                                                                                                item
                                                                                            )
                                                                                        )
                                                                                    }}</span
                                                                                >
                                                                            </div>
                                                                            <div
                                                                                class="col-md-2"
                                                                            ></div>
                                                                        </div>

                                                                        <!-- Run Charge -->
                                                                        <div
                                                                            class="row color-line"
                                                                            v-if="
                                                                                getRunChargeTotal(
                                                                                    item
                                                                                ) >
                                                                                0
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="col-md-6"
                                                                            >
                                                                                <div
                                                                                    class="d-flex align-items-center base_product_box_custom"
                                                                                >
                                                                                    <div>
                                                                                        {{
                                                                                            getRollupFeeDisplayName(
                                                                                                12
                                                                                            ) ||
                                                                                            "Run Charge"
                                                                                        }}
                                                                                    </div>
                                                                                    <div
                                                                                        class="tooltip-wrapper"
                                                                                        v-if="
                                                                                            getRunChargeTotal(
                                                                                                item
                                                                                            ) >
                                                                                                0 &&
                                                                                            getBreakdownData(
                                                                                                item,
                                                                                                'run_charge_breakdown'
                                                                                            ) &&
                                                                                            getBreakdownData(
                                                                                                item,
                                                                                                'run_charge_breakdown'
                                                                                            )
                                                                                                .length >
                                                                                                0
                                                                                        "
                                                                                        @click.stop="
                                                                                            toggleCostTooltip(
                                                                                                index,
                                                                                                'runCharge'
                                                                                            )
                                                                                        "
                                                                                    >
                                                                                        <svg
                                                                                            class="ml_6 info-icon-svg"
                                                                                            width="16"
                                                                                            height="16"
                                                                                            viewBox="0 0 16 16"
                                                                                            fill="none"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                            aria-hidden="true"
                                                                                            focusable="false"
                                                                                        >
                                                                                            <path d="M8.0026 14.6654C11.6693 14.6654 14.6693 11.6654 14.6693 7.9987C14.6693 4.33203 11.6693 1.33203 8.0026 1.33203C4.33594 1.33203 1.33594 4.33203 1.33594 7.9987C1.33594 11.6654 4.33594 14.6654 8.0026 14.6654Z" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                            <path d="M8 5.33203V8.66536" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                            <path d="M8 10.668H8.00599" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                        </svg>
                                                                                        <div
                                                                                            v-if="
                                                                                                costTooltipVisible ===
                                                                                                `${index}-runCharge`
                                                                                            "
                                                                                            class="tooltip-content is-visible"
                                                                                        >
                                                                                            <div
                                                                                                class="tooltip-header"
                                                                                            >
                                                                                                <h4>
                                                                                                    {{
                                                                                                        getRollupFeeDisplayName(
                                                                                                            12
                                                                                                        ) ||
                                                                                                        "Run Charge"
                                                                                                    }}
                                                                                                    Breakdown
                                                                                                </h4>
                                                                                                <svg
                                                                                                    class="close-icon"
                                                                                                    @click.stop="
                                                                                                        closeCostTooltip(
                                                                                                            index
                                                                                                        )
                                                                                                    "
                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                    viewBox="0 0 24 24"
                                                                                                    fill="none"
                                                                                                    stroke="currentColor"
                                                                                                    stroke-width="2"
                                                                                                    stroke-linecap="round"
                                                                                                    stroke-linejoin="round"
                                                                                                >
                                                                                                    <line
                                                                                                        x1="18"
                                                                                                        y1="6"
                                                                                                        x2="6"
                                                                                                        y2="18"
                                                                                                    ></line>
                                                                                                    <line
                                                                                                        x1="6"
                                                                                                        y1="6"
                                                                                                        x2="18"
                                                                                                        y2="18"
                                                                                                    ></line>
                                                                                                </svg>
                                                                                            </div>
                                                                                            <div
                                                                                                class="tooltip-body"
                                                                                            >
                                                                                                <table
                                                                                                    class="base-fee-table"
                                                                                                >
                                                                                                    <thead>
                                                                                                        <tr>
                                                                                                            <th>
                                                                                                                Item
                                                                                                            </th>
                                                                                                            <th>
                                                                                                                Qty
                                                                                                            </th>
                                                                                                            <th>
                                                                                                                Amt
                                                                                                            </th>
                                                                                                            <th>
                                                                                                                Total
                                                                                                            </th>
                                                                                                        </tr>
                                                                                                    </thead>
                                                                                                    <tbody>
                                                                                                        <template
                                                                                                            v-for="(
                                                                                                                breakdownItem,
                                                                                                                breakdown_index
                                                                                                            ) in getBreakdownData(
                                                                                                                item,
                                                                                                                'run_charge_breakdown'
                                                                                                            )"
                                                                                                        >
                                                                                                            <template
                                                                                                                v-if="
                                                                                                                    breakdownItem.items &&
                                                                                                                    Array.isArray(
                                                                                                                        breakdownItem.items
                                                                                                                    )
                                                                                                                "
                                                                                                            >
                                                                                                                <tr
                                                                                                                    v-for="(
                                                                                                                        charge_item,
                                                                                                                        charge_index
                                                                                                                    ) in breakdownItem.items.filter(
                                                                                                                        (
                                                                                                                            i
                                                                                                                        ) =>
                                                                                                                            i.type !==
                                                                                                                            'total'
                                                                                                                    )"
                                                                                                                    :key="`breakdown-${breakdown_index}-charge-${charge_index}`"
                                                                                                                >
                                                                                                                    <td>
                                                                                                                        <strong
                                                                                                                            v-if="
                                                                                                                                charge_item.type ===
                                                                                                                                'location'
                                                                                                                            "
                                                                                                                            >{{
                                                                                                                                charge_item.name
                                                                                                                            }}</strong
                                                                                                                        ><span
                                                                                                                            v-else
                                                                                                                            >{{
                                                                                                                                charge_item.name
                                                                                                                            }}</span
                                                                                                                        >
                                                                                                                    </td>
                                                                                                                    <td>
                                                                                                                        {{
                                                                                                                            charge_item.qty ===
                                                                                                                                "INCL" ||
                                                                                                                            charge_item.qty ===
                                                                                                                                "-"
                                                                                                                                ? charge_item.qty
                                                                                                                                : charge_item.qty ||
                                                                                                                                  "-"
                                                                                                                        }}
                                                                                                                    </td>
                                                                                                                    <td>
                                                                                                                        {{
                                                                                                                            charge_item.amt ===
                                                                                                                                "INCL" ||
                                                                                                                            charge_item.amt ===
                                                                                                                                "-"
                                                                                                                                ? charge_item.amt
                                                                                                                                : charge_item.amt
                                                                                                                                ? icPriceFormat(
                                                                                                                                      parseFloat(
                                                                                                                                          charge_item.amt ||
                                                                                                                                              0
                                                                                                                                      )
                                                                                                                                  )
                                                                                                                                : "-"
                                                                                                                        }}
                                                                                                                    </td>
                                                                                                                    <td>
                                                                                                                        {{
                                                                                                                            charge_item.total ===
                                                                                                                                "INCL" ||
                                                                                                                            charge_item.total ===
                                                                                                                                "-"
                                                                                                                                ? charge_item.total
                                                                                                                                : icPriceFormat(
                                                                                                                                      parseFloat(
                                                                                                                                          charge_item.total ||
                                                                                                                                              0
                                                                                                                                      )
                                                                                                                                  )
                                                                                                                        }}
                                                                                                                    </td>
                                                                                                                </tr>
                                                                                                                <tr
                                                                                                                    v-if="
                                                                                                                        breakdownItem.items.find(
                                                                                                                            (
                                                                                                                                i
                                                                                                                            ) =>
                                                                                                                                i.type ===
                                                                                                                                'total'
                                                                                                                        )
                                                                                                                    "
                                                                                                                    class="total-row"
                                                                                                                    :key="`total-${breakdown_index}`"
                                                                                                                >
                                                                                                                    <td
                                                                                                                        class="text_left"
                                                                                                                        colspan="3"
                                                                                                                    >
                                                                                                                        <strong
                                                                                                                            >Location
                                                                                                                            Total</strong
                                                                                                                        >
                                                                                                                    </td>
                                                                                                                    <td
                                                                                                                        class="text_right"
                                                                                                                    >
                                                                                                                        <strong
                                                                                                                            >{{
                                                                                                                                icPriceFormat(
                                                                                                                                    parseFloat(
                                                                                                                                        breakdownItem.items.find(
                                                                                                                                            (
                                                                                                                                                i
                                                                                                                                            ) =>
                                                                                                                                                i.type ===
                                                                                                                                                "total"
                                                                                                                                        )
                                                                                                                                            .total ||
                                                                                                                                            0
                                                                                                                                    )
                                                                                                                                )
                                                                                                                            }}</strong
                                                                                                                        >
                                                                                                                    </td>
                                                                                                                </tr>
                                                                                                            </template>
                                                                                                            <tr
                                                                                                                v-if="
                                                                                                                    breakdownItem.type ===
                                                                                                                    'otherService'
                                                                                                                "
                                                                                                                :key="`service-${breakdown_index}`"
                                                                                                            >
                                                                                                                <td>
                                                                                                                    {{
                                                                                                                        breakdownItem.type ===
                                                                                                                            "otherService" &&
                                                                                                                        breakdownItem.ecomm_display
                                                                                                                            ? breakdownItem.ecomm_display
                                                                                                                            : breakdownItem.name
                                                                                                                    }}
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    -
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    -
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    {{
                                                                                                                        breakdownItem.total ===
                                                                                                                            "INCL" ||
                                                                                                                        breakdownItem.total ===
                                                                                                                            "-"
                                                                                                                            ? breakdownItem.total
                                                                                                                            : icPriceFormat(
                                                                                                                                  parseFloat(
                                                                                                                                      breakdownItem.total ||
                                                                                                                                          0
                                                                                                                                  )
                                                                                                                              )
                                                                                                                    }}
                                                                                                                </td>
                                                                                                            </tr>
                                                                                                        </template>
                                                                                                        <tr
                                                                                                            v-if="
                                                                                                                getRunChargeTotal(
                                                                                                                    item
                                                                                                                ) >
                                                                                                                0
                                                                                                            "
                                                                                                            class="total-row"
                                                                                                        >
                                                                                                            <td
                                                                                                                class="text_left"
                                                                                                                colspan="3"
                                                                                                            >
                                                                                                                <strong
                                                                                                                    >Total</strong
                                                                                                                >
                                                                                                            </td>
                                                                                                            <td
                                                                                                                class="text_right"
                                                                                                            >
                                                                                                                <strong
                                                                                                                    >{{
                                                                                                                        icPriceFormat(
                                                                                                                            getRunChargeTotal(
                                                                                                                                item
                                                                                                                            )
                                                                                                                        )
                                                                                                                    }}</strong
                                                                                                                >
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    </tbody>
                                                                                                </table>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                class="col-md-5"
                                                                            >
                                                                                <span
                                                                                    class="price_right"
                                                                                >
                                                                                    {{
                                                                                        icPriceFormat(
                                                                                            getRunChargeTotal(
                                                                                                item
                                                                                            )
                                                                                        )
                                                                                    }}</span
                                                                                >
                                                                            </div>
                                                                            <div
                                                                                class="col-md-2"
                                                                            ></div>
                                                                        </div>

                                                                        <!-- Set Up Fees -->
                                                                        <div
                                                                            class="row color-line"
                                                                            v-if="
                                                                                getSetupFeesTotal(
                                                                                    item
                                                                                ) >
                                                                                    0 ||
                                                                                (getBreakdownData(
                                                                                    item,
                                                                                    'setup_fees_details'
                                                                                ) &&
                                                                                    typeof getBreakdownData(
                                                                                        item,
                                                                                        'setup_fees_details'
                                                                                    ) ===
                                                                                        'object')
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="col-md-6"
                                                                            >
                                                                                <div
                                                                                    class="d-flex align-items-center base_product_box_custom"
                                                                                >
                                                                                    <div>
                                                                                        {{
                                                                                            getRollupFeeDisplayName(
                                                                                                2
                                                                                            ) ||
                                                                                            "Set Up Fees"
                                                                                        }}
                                                                                    </div>
                                                                                    <div
                                                                                        class="tooltip-wrapper"
                                                                                        v-if="
                                                                                            getSetupFeesTotal(
                                                                                                item
                                                                                            ) >
                                                                                                0 &&
                                                                                            getBreakdownData(
                                                                                                item,
                                                                                                'setup_fees_details'
                                                                                            ) &&
                                                                                            typeof getBreakdownData(
                                                                                                item,
                                                                                                'setup_fees_details'
                                                                                            ) ===
                                                                                                'object'
                                                                                        "
                                                                                        @click.stop="
                                                                                            toggleCostTooltip(
                                                                                                index,
                                                                                                'setupFees'
                                                                                            )
                                                                                        "
                                                                                    >
                                                                                        <svg
                                                                                            class="ml_6 info-icon-svg"
                                                                                            width="16"
                                                                                            height="16"
                                                                                            viewBox="0 0 16 16"
                                                                                            fill="none"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                            aria-hidden="true"
                                                                                            focusable="false"
                                                                                        >
                                                                                            <path d="M8.0026 14.6654C11.6693 14.6654 14.6693 11.6654 14.6693 7.9987C14.6693 4.33203 11.6693 1.33203 8.0026 1.33203C4.33594 1.33203 1.33594 4.33203 1.33594 7.9987C1.33594 11.6654 4.33594 14.6654 8.0026 14.6654Z" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                            <path d="M8 5.33203V8.66536" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                            <path d="M8 10.668H8.00599" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                        </svg>
                                                                                        <div
                                                                                            v-if="
                                                                                                costTooltipVisible ===
                                                                                                `${index}-setupFees`
                                                                                            "
                                                                                            class="tooltip-content is-visible"
                                                                                        >
                                                                                            <div
                                                                                                class="tooltip-header"
                                                                                            >
                                                                                                <h4>
                                                                                                    {{
                                                                                                        getRollupFeeDisplayName(
                                                                                                            2
                                                                                                        ) ||
                                                                                                        "Set Up Fees"
                                                                                                    }}
                                                                                                    Breakdown
                                                                                                </h4>
                                                                                                <svg
                                                                                                    class="close-icon"
                                                                                                    @click.stop="
                                                                                                        closeCostTooltip(
                                                                                                            index
                                                                                                        )
                                                                                                    "
                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                    viewBox="0 0 24 24"
                                                                                                    fill="none"
                                                                                                    stroke="currentColor"
                                                                                                    stroke-width="2"
                                                                                                    stroke-linecap="round"
                                                                                                    stroke-linejoin="round"
                                                                                                >
                                                                                                    <line
                                                                                                        x1="18"
                                                                                                        y1="6"
                                                                                                        x2="6"
                                                                                                        y2="18"
                                                                                                    ></line>
                                                                                                    <line
                                                                                                        x1="6"
                                                                                                        y1="6"
                                                                                                        x2="18"
                                                                                                        y2="18"
                                                                                                    ></line>
                                                                                                </svg>
                                                                                            </div>
                                                                                            <div
                                                                                                class="tooltip-body"
                                                                                            >
                                                                                                <table
                                                                                                    class="base-fee-table"
                                                                                                >
                                                                                                    <thead>
                                                                                                        <tr>
                                                                                                            <th>
                                                                                                                Fee
                                                                                                            </th>
                                                                                                            <th>
                                                                                                                Qty
                                                                                                            </th>
                                                                                                            <th>
                                                                                                                Amt
                                                                                                            </th>
                                                                                                            <th>
                                                                                                                Total
                                                                                                            </th>
                                                                                                        </tr>
                                                                                                    </thead>
                                                                                                    <tbody>
                                                                                                        <template
                                                                                                            v-if="
                                                                                                                getBreakdownData(
                                                                                                                    item,
                                                                                                                    'setup_fees_details'
                                                                                                                )
                                                                                                                    .locations &&
                                                                                                                Array.isArray(
                                                                                                                    getBreakdownData(
                                                                                                                        item,
                                                                                                                        'setup_fees_details'
                                                                                                                    )
                                                                                                                        .locations
                                                                                                                )
                                                                                                            "
                                                                                                        >
                                                                                                            <tr
                                                                                                                v-for="(
                                                                                                                    location,
                                                                                                                    loc_index
                                                                                                                ) in getBreakdownData(
                                                                                                                    item,
                                                                                                                    'setup_fees_details'
                                                                                                                )
                                                                                                                    .locations"
                                                                                                                :key="
                                                                                                                    'loc-' +
                                                                                                                    loc_index
                                                                                                                "
                                                                                                            >
                                                                                                                <td>
                                                                                                                    {{
                                                                                                                        location.name ||
                                                                                                                        `Location ${
                                                                                                                            loc_index +
                                                                                                                            1
                                                                                                                        }`
                                                                                                                    }}
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    {{
                                                                                                                        location.quantity ||
                                                                                                                        "-"
                                                                                                                    }}
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    {{
                                                                                                                        location.per_price
                                                                                                                            ? icPriceFormat(
                                                                                                                                  parseFloat(
                                                                                                                                      location.per_price ||
                                                                                                                                          0
                                                                                                                                  )
                                                                                                                              )
                                                                                                                            : "-"
                                                                                                                    }}
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    {{
                                                                                                                        icPriceFormat(
                                                                                                                            parseFloat(
                                                                                                                                location.total ||
                                                                                                                                    0
                                                                                                                            )
                                                                                                                        )
                                                                                                                    }}
                                                                                                                </td>
                                                                                                            </tr>
                                                                                                        </template>
                                                                                                        <template
                                                                                                            v-if="
                                                                                                                getBreakdownData(
                                                                                                                    item,
                                                                                                                    'setup_fees_details'
                                                                                                                )
                                                                                                                    .services &&
                                                                                                                Array.isArray(
                                                                                                                    getBreakdownData(
                                                                                                                        item,
                                                                                                                        'setup_fees_details'
                                                                                                                    )
                                                                                                                        .services
                                                                                                                )
                                                                                                            "
                                                                                                        >
                                                                                                            <tr
                                                                                                                v-for="(
                                                                                                                    service,
                                                                                                                    service_index
                                                                                                                ) in getBreakdownData(
                                                                                                                    item,
                                                                                                                    'setup_fees_details'
                                                                                                                )
                                                                                                                    .services"
                                                                                                                :key="
                                                                                                                    'service-' +
                                                                                                                    service_index
                                                                                                                "
                                                                                                            >
                                                                                                                <td>
                                                                                                                    {{
                                                                                                                        service.ecomm_display ||
                                                                                                                        service.service_name ||
                                                                                                                        `Service ${
                                                                                                                            service_index +
                                                                                                                            1
                                                                                                                        }`
                                                                                                                    }}
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    -
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    -
                                                                                                                </td>
                                                                                                                <td>
                                                                                                                    {{
                                                                                                                        icPriceFormat(
                                                                                                                            parseFloat(
                                                                                                                                service.total ||
                                                                                                                                    0
                                                                                                                            )
                                                                                                                        )
                                                                                                                    }}
                                                                                                                </td>
                                                                                                            </tr>
                                                                                                        </template>
                                                                                                        <tr
                                                                                                            v-if="
                                                                                                                getSetupFeesTotal(
                                                                                                                    item
                                                                                                                ) >
                                                                                                                0
                                                                                                            "
                                                                                                            class="total-row"
                                                                                                        >
                                                                                                            <td
                                                                                                                class="text_left"
                                                                                                                colspan="3"
                                                                                                            >
                                                                                                                <strong
                                                                                                                    >Total</strong
                                                                                                                >
                                                                                                            </td>
                                                                                                            <td
                                                                                                                class="text_right"
                                                                                                            >
                                                                                                                <strong
                                                                                                                    >{{
                                                                                                                        icPriceFormat(
                                                                                                                            getSetupFeesTotal(
                                                                                                                                item
                                                                                                                            )
                                                                                                                        )
                                                                                                                    }}</strong
                                                                                                                >
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    </tbody>
                                                                                                </table>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                class="col-md-5"
                                                                            >
                                                                                <span
                                                                                    class="price_right"
                                                                                    >{{
                                                                                        icPriceFormat(
                                                                                            getSetupFeesTotal(
                                                                                                item
                                                                                            )
                                                                                        )
                                                                                    }}</span
                                                                                >
                                                                            </div>
                                                                            <div
                                                                                class="col-md-2"
                                                                            ></div>
                                                                        </div>

                                                                        <!-- Custom Color Fee -->
                                                                        <div
                                                                            class="row color-line"
                                                                            v-if="
                                                                                getCustomColorFeeTotal(
                                                                                    item
                                                                                ) >
                                                                                    0 ||
                                                                                (getBreakdownData(
                                                                                    item,
                                                                                    'custom_color_fee'
                                                                                ) &&
                                                                                    getBreakdownData(
                                                                                        item,
                                                                                        'custom_color_fee'
                                                                                    )
                                                                                        .length >
                                                                                        0)
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="col-md-6"
                                                                            >
                                                                                <div
                                                                                    class="d-flex align-items-center base_product_box_custom"
                                                                                >
                                                                                    <div>
                                                                                        {{
                                                                                            getRollupFeeDisplayName(
                                                                                                13
                                                                                            ) ||
                                                                                            "Custom Color Fee"
                                                                                        }}
                                                                                    </div>
                                                                                    <div
                                                                                        class="tooltip-wrapper"
                                                                                        v-if="
                                                                                            getCustomColorFeeTotal(
                                                                                                item
                                                                                            ) >
                                                                                                0 &&
                                                                                            getBreakdownData(
                                                                                                item,
                                                                                                'custom_color_fee'
                                                                                            ) &&
                                                                                            getBreakdownData(
                                                                                                item,
                                                                                                'custom_color_fee'
                                                                                            )
                                                                                                .length >
                                                                                                0
                                                                                        "
                                                                                        @click.stop="
                                                                                            toggleCostTooltip(
                                                                                                index,
                                                                                                'customColorFee'
                                                                                            )
                                                                                        "
                                                                                    >
                                                                                        <svg
                                                                                            class="ml_6 info-icon-svg"
                                                                                            width="16"
                                                                                            height="16"
                                                                                            viewBox="0 0 16 16"
                                                                                            fill="none"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                            aria-hidden="true"
                                                                                            focusable="false"
                                                                                        >
                                                                                            <path d="M8.0026 14.6654C11.6693 14.6654 14.6693 11.6654 14.6693 7.9987C14.6693 4.33203 11.6693 1.33203 8.0026 1.33203C4.33594 1.33203 1.33594 4.33203 1.33594 7.9987C1.33594 11.6654 4.33594 14.6654 8.0026 14.6654Z" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                            <path d="M8 5.33203V8.66536" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                            <path d="M8 10.668H8.00599" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                        </svg>
                                                                                        <div
                                                                                            v-if="
                                                                                                costTooltipVisible ===
                                                                                                `${index}-customColorFee`
                                                                                            "
                                                                                            class="tooltip-content is-visible"
                                                                                        >
                                                                                            <div
                                                                                                class="tooltip-header"
                                                                                            >
                                                                                                <h4>
                                                                                                    {{
                                                                                                        getRollupFeeDisplayName(
                                                                                                            13
                                                                                                        ) ||
                                                                                                        "Custom Color Fee"
                                                                                                    }}
                                                                                                    Breakdown
                                                                                                </h4>
                                                                                                <svg
                                                                                                    class="close-icon"
                                                                                                    @click.stop="
                                                                                                        closeCostTooltip(
                                                                                                            index
                                                                                                        )
                                                                                                    "
                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                    viewBox="0 0 24 24"
                                                                                                    fill="none"
                                                                                                    stroke="currentColor"
                                                                                                    stroke-width="2"
                                                                                                    stroke-linecap="round"
                                                                                                    stroke-linejoin="round"
                                                                                                >
                                                                                                    <line
                                                                                                        x1="18"
                                                                                                        y1="6"
                                                                                                        x2="6"
                                                                                                        y2="18"
                                                                                                    ></line>
                                                                                                    <line
                                                                                                        x1="6"
                                                                                                        y1="6"
                                                                                                        x2="18"
                                                                                                        y2="18"
                                                                                                    ></line>
                                                                                                </svg>
                                                                                            </div>
                                                                                            <div
                                                                                                class="tooltip-body"
                                                                                            >
                                                                                                <table
                                                                                                    class="base-fee-table"
                                                                                                >
                                                                                                    <thead>
                                                                                                        <tr>
                                                                                                            <th>
                                                                                                                Fee
                                                                                                            </th>
                                                                                                            <th>
                                                                                                                Qty
                                                                                                            </th>
                                                                                                            <th>
                                                                                                                Amt
                                                                                                            </th>
                                                                                                            <th>
                                                                                                                Total
                                                                                                            </th>
                                                                                                        </tr>
                                                                                                    </thead>
                                                                                                    <tbody>
                                                                                                        <tr
                                                                                                            v-for="(
                                                                                                                fee,
                                                                                                                fee_index
                                                                                                            ) in getBreakdownData(
                                                                                                                item,
                                                                                                                'custom_color_fee'
                                                                                                            )"
                                                                                                            :key="
                                                                                                                fee_index
                                                                                                            "
                                                                                                        >
                                                                                                            <td>
                                                                                                                {{
                                                                                                                    fee.type ===
                                                                                                                        "service" &&
                                                                                                                    fee.ecomm_display
                                                                                                                        ? fee.ecomm_display
                                                                                                                        : fee.name ||
                                                                                                                          "Fee"
                                                                                                                }}
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                {{
                                                                                                                    fee.qty ||
                                                                                                                    "-"
                                                                                                                }}
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                {{
                                                                                                                    fee.amt
                                                                                                                        ? icPriceFormat(
                                                                                                                              parseFloat(
                                                                                                                                  fee.amt ||
                                                                                                                                      0
                                                                                                                              )
                                                                                                                          )
                                                                                                                        : "-"
                                                                                                                }}
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                {{
                                                                                                                    icPriceFormat(
                                                                                                                        parseFloat(
                                                                                                                            fee.total ||
                                                                                                                                0
                                                                                                                        )
                                                                                                                    )
                                                                                                                }}
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                        <tr
                                                                                                            v-if="
                                                                                                                getCustomColorFeeTotal(
                                                                                                                    item
                                                                                                                ) >
                                                                                                                0
                                                                                                            "
                                                                                                            class="total-row"
                                                                                                        >
                                                                                                            <td
                                                                                                                class="text_left"
                                                                                                                colspan="3"
                                                                                                            >
                                                                                                                <strong
                                                                                                                    >Total</strong
                                                                                                                >
                                                                                                            </td>
                                                                                                            <td
                                                                                                                class="text_right"
                                                                                                            >
                                                                                                                <strong
                                                                                                                    >{{
                                                                                                                        icPriceFormat(
                                                                                                                            getCustomColorFeeTotal(
                                                                                                                                item
                                                                                                                            )
                                                                                                                        )
                                                                                                                    }}</strong
                                                                                                                >
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    </tbody>
                                                                                                </table>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                class="col-md-5"
                                                                            >
                                                                                <span
                                                                                    class="price_right"
                                                                                    >{{
                                                                                        icPriceFormat(
                                                                                            getCustomColorFeeTotal(
                                                                                                item
                                                                                            )
                                                                                        )
                                                                                    }}</span
                                                                                >
                                                                            </div>
                                                                            <div
                                                                                class="col-md-2"
                                                                            ></div>
                                                                        </div>

                                                                        <!-- Rush Fee -->
                                                                        <div
                                                                            class="row color-line"
                                                                            v-if="
                                                                                getRushFeeTotal(
                                                                                    item
                                                                                ) >
                                                                                0
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="col-md-6"
                                                                            >
                                                                                <div
                                                                                    class="d-flex align-items-center base_product_box_custom"
                                                                                >
                                                                                    <div>
                                                                                        {{
                                                                                            getRollupFeeDisplayName(
                                                                                                6
                                                                                            ) ||
                                                                                            "Rush Fee"
                                                                                        }}
                                                                                    </div>
                                                                                    <div
                                                                                        class="tooltip-wrapper"
                                                                                        v-if="
                                                                                            getRushFeeTotal(
                                                                                                item
                                                                                            ) >
                                                                                                0 &&
                                                                                            getBreakdownData(
                                                                                                item,
                                                                                                'rush_fee_breakdown'
                                                                                            ) &&
                                                                                            getBreakdownData(
                                                                                                item,
                                                                                                'rush_fee_breakdown'
                                                                                            )
                                                                                                .services &&
                                                                                            getBreakdownData(
                                                                                                item,
                                                                                                'rush_fee_breakdown'
                                                                                            )
                                                                                                .services
                                                                                                .length >
                                                                                                0
                                                                                        "
                                                                                        @click.stop="
                                                                                            toggleCostTooltip(
                                                                                                index,
                                                                                                'rushFee'
                                                                                            )
                                                                                        "
                                                                                    >
                                                                                        <svg
                                                                                            class="ml_6 info-icon-svg"
                                                                                            width="16"
                                                                                            height="16"
                                                                                            viewBox="0 0 16 16"
                                                                                            fill="none"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                            aria-hidden="true"
                                                                                            focusable="false"
                                                                                        >
                                                                                            <path d="M8.0026 14.6654C11.6693 14.6654 14.6693 11.6654 14.6693 7.9987C14.6693 4.33203 11.6693 1.33203 8.0026 1.33203C4.33594 1.33203 1.33594 4.33203 1.33594 7.9987C1.33594 11.6654 4.33594 14.6654 8.0026 14.6654Z" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                            <path d="M8 5.33203V8.66536" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                            <path d="M8 10.668H8.00599" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                        </svg>
                                                                                        <div
                                                                                            v-if="
                                                                                                getCostTooltip(
                                                                                                    index
                                                                                                ) ===
                                                                                                'rushFee'
                                                                                            "
                                                                                            class="tooltip-content is-visible"
                                                                                        >
                                                                                            <div
                                                                                                class="tooltip-header"
                                                                                            >
                                                                                                <h4>
                                                                                                    {{
                                                                                                        getRollupFeeDisplayName(
                                                                                                            6
                                                                                                        ) ||
                                                                                                        "Rush Fee"
                                                                                                    }}
                                                                                                    Breakdown
                                                                                                </h4>
                                                                                                <svg
                                                                                                    class="close-icon"
                                                                                                    @click.stop="
                                                                                                        closeCostTooltip(
                                                                                                            index
                                                                                                        )
                                                                                                    "
                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                    viewBox="0 0 24 24"
                                                                                                    fill="none"
                                                                                                    stroke="currentColor"
                                                                                                    stroke-width="2"
                                                                                                    stroke-linecap="round"
                                                                                                    stroke-linejoin="round"
                                                                                                >
                                                                                                    <line
                                                                                                        x1="18"
                                                                                                        y1="6"
                                                                                                        x2="6"
                                                                                                        y2="18"
                                                                                                    ></line>
                                                                                                    <line
                                                                                                        x1="6"
                                                                                                        y1="6"
                                                                                                        x2="18"
                                                                                                        y2="18"
                                                                                                    ></line>
                                                                                                </svg>
                                                                                            </div>
                                                                                            <div
                                                                                                class="tooltip-body"
                                                                                            >
                                                                                                <table
                                                                                                    class="base-fee-table"
                                                                                                >
                                                                                                    <thead>
                                                                                                        <tr>
                                                                                                            <th>
                                                                                                                Service
                                                                                                            </th>
                                                                                                            <th>
                                                                                                                Qty
                                                                                                            </th>
                                                                                                            <th>
                                                                                                                Amt
                                                                                                            </th>
                                                                                                            <th>
                                                                                                                Total
                                                                                                            </th>
                                                                                                        </tr>
                                                                                                    </thead>
                                                                                                    <tbody>
                                                                                                        <tr
                                                                                                            v-for="(
                                                                                                                service,
                                                                                                                service_index
                                                                                                            ) in getBreakdownData(
                                                                                                                item,
                                                                                                                'rush_fee_breakdown'
                                                                                                            )
                                                                                                                .services"
                                                                                                            :key="
                                                                                                                'rush-service-' +
                                                                                                                service_index
                                                                                                            "
                                                                                                        >
                                                                                                            <td>
                                                                                                                {{
                                                                                                                    getRushServiceNameWithDate(
                                                                                                                        service,
                                                                                                                        item
                                                                                                                    )
                                                                                                                }}
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                {{
                                                                                                                    service.quantity ||
                                                                                                                    service.qty ||
                                                                                                                    "-"
                                                                                                                }}
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                {{
                                                                                                                    service.retail_cost
                                                                                                                        ? icPriceFormat(
                                                                                                                              parseFloat(
                                                                                                                                  service.retail_cost ||
                                                                                                                                      0
                                                                                                                              )
                                                                                                                          )
                                                                                                                        : "-"
                                                                                                                }}
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                {{
                                                                                                                    icPriceFormat(
                                                                                                                        parseFloat(
                                                                                                                            service.total !==
                                                                                                                                undefined &&
                                                                                                                                service.total !==
                                                                                                                                    null
                                                                                                                                ? service.total
                                                                                                                                : service.retail_cost ||
                                                                                                                                      0
                                                                                                                        )
                                                                                                                    )
                                                                                                                }}
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                        <tr
                                                                                                            v-if="
                                                                                                                getRushFeeTotal(
                                                                                                                    item
                                                                                                                ) >
                                                                                                                0
                                                                                                            "
                                                                                                            class="total-row"
                                                                                                        >
                                                                                                            <td
                                                                                                                class="text_left"
                                                                                                                colspan="3"
                                                                                                            >
                                                                                                                <strong
                                                                                                                    >Total</strong
                                                                                                                >
                                                                                                            </td>
                                                                                                            <td
                                                                                                                class="text_right"
                                                                                                            >
                                                                                                                <strong
                                                                                                                    >{{
                                                                                                                        icPriceFormat(
                                                                                                                            getRushFeeTotal(
                                                                                                                                item
                                                                                                                            )
                                                                                                                        )
                                                                                                                    }}</strong
                                                                                                                >
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    </tbody>
                                                                                                </table>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                class="col-md-5"
                                                                            >
                                                                                <span
                                                                                    class="price_right"
                                                                                >
                                                                                    {{
                                                                                        icPriceFormat(
                                                                                            getRushFeeTotal(
                                                                                                item
                                                                                            )
                                                                                        )
                                                                                    }}</span
                                                                                >
                                                                            </div>
                                                                            <div
                                                                                class="col-md-2"
                                                                            ></div>
                                                                        </div>

                                                                        <!-- Additional Design Service -->
                                                                        <div
                                                                            class="row color-line"
                                                                            v-if="
                                                                                item.design_fee >
                                                                                0
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="col-md-6"
                                                                            >
                                                                                <div
                                                                                    class="d-flex align-items-center base_product_box_custom"
                                                                                >
                                                                                    <div>
                                                                                        Additional
                                                                                        Design
                                                                                        Service
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                class="col-md-5"
                                                                            >
                                                                                {{
                                                                                    icPriceFormat(
                                                                                        parseFloat(
                                                                                            item.design_fee ||
                                                                                                0
                                                                                        )
                                                                                    )
                                                                                }}
                                                                            </div>
                                                                            <div
                                                                                class="col-md-2"
                                                                            ></div>
                                                                        </div>

                                                                        <!-- Patch Cost -->
                                                                        <div
                                                                            class="row color-line"
                                                                            v-if="
                                                                                parseFloat(item.patch_cost || 0) >
                                                                                0
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="col-md-6"
                                                                            >
                                                                                <div
                                                                                    class="d-flex align-items-center base_product_box_custom"
                                                                                >
                                                                                    <div>
                                                                                        Patch
                                                                                        Cost
                                                                                    </div>
                                                                                    <div
                                                                                        class="tooltip-wrapper"
                                                                                        v-if="item.patch_cost_details && item.patch_cost_details.length > 0"
                                                                                        @click.stop="toggleCostTooltip(index, 'patchCost')"
                                                                                    >
                                                                                        <svg
                                                                                            class="ml_6 info-icon-svg"
                                                                                            width="16"
                                                                                            height="16"
                                                                                            viewBox="0 0 16 16"
                                                                                            fill="none"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                            aria-hidden="true"
                                                                                            focusable="false"
                                                                                        >
                                                                                            <path d="M8.0026 14.6654C11.6693 14.6654 14.6693 11.6654 14.6693 7.9987C14.6693 4.33203 11.6693 1.33203 8.0026 1.33203C4.33594 1.33203 1.33594 4.33203 1.33594 7.9987C1.33594 11.6654 4.33594 14.6654 8.0026 14.6654Z" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                            <path d="M8 5.33203V8.66536" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                            <path d="M8 10.668H8.00599" stroke="#929292" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                        </svg>
                                                                                        <div
                                                                                            v-if="costTooltipVisible === `${index}-patchCost`"
                                                                                            class="tooltip-content is-visible"
                                                                                        >
                                                                                            <div class="tooltip-header">
                                                                                                <h4>Patch Breakdown</h4>
                                                                                                <svg
                                                                                                    class="close-icon"
                                                                                                    @click.stop="costTooltipVisible = null"
                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                    viewBox="0 0 24 24"
                                                                                                    fill="none"
                                                                                                    stroke="currentColor"
                                                                                                    stroke-width="2"
                                                                                                    stroke-linecap="round"
                                                                                                    stroke-linejoin="round"
                                                                                                >
                                                                                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                                                                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                                                                                </svg>
                                                                                            </div>
                                                                                            <div class="tooltip-body">
                                                                                                <table class="base-fee-table">
                                                                                                    <thead>
                                                                                                        <tr>
                                                                                                            <th>Fee</th>
                                                                                                            <th>QTY</th>
                                                                                                            <th>Amount</th>
                                                                                                            <th>Total</th>
                                                                                                        </tr>
                                                                                                    </thead>
                                                                                                    <tbody>
                                        <template v-for="(row, pIdx) in item.patch_cost_details">
                                            <!-- Base Patch Row (only when charged patches exist) -->
                                            <tr
                                                v-if="parseInt(row.charged_quantity || 0, 10) > 0"
                                                :key="'patch-base-' + pIdx"
                                            >
                                                <td>{{ row.patchName }}{{ row.location ? ' (' + row.location + ')' : '' }}</td>
                                                <td>{{ row.slab }}</td>
                                                <td>{{ icPriceFormat(parseFloat(row.perPatchPrice || 0)) }}</td>
                                                <td>{{ icPriceFormat(parseFloat((parseInt(row.slab || 0, 10) || 0) * (parseFloat(row.perPatchPrice || 0))) ) }}</td>
                                            </tr>
                                            <!-- Inventory Row -->
                                            <tr
                                                v-if="parseInt(row.inventory_used || 0, 10) > 0"
                                                :key="'patch-inv-' + pIdx"
                                            >
                                                <td>Inventory</td>
                                                <td>
                                                    {{ parseInt(row.charged_quantity || 0, 10) > 0 ? '-' + row.inventory_used : row.inventory_used }}
                                                </td>
                                                <td>{{ icPriceFormat(parseFloat(row.perPatchPrice || 0)) }}</td>
                                                <td
                                                    class="font-weight-bold"
                                                    :class="{
                                                        'text-danger':
                                                            parseInt(row.charged_quantity || 0, 10) > 0
                                                    }"
                                                >
                                                    {{
                                                        parseInt(row.charged_quantity || 0, 10) > 0
                                                            ? icPriceFormat(
                                                                  -1 * (parseInt(row.inventory_used || 0, 10) || 0) * (parseFloat(row.perPatchPrice || 0))
                                                              )
                                                            : icPriceFormat(
                                                                  (parseInt(row.inventory_used || 0, 10) || 0) * (parseFloat(row.perPatchPrice || 0))
                                                              )
                                                    }}
                                                </td>
                                            </tr>
                                        </template>
                                                                                                        <tr class="total-row">
                                                                                                            <td colspan="3"><strong>Total</strong></td>
                                                                                                            <td><strong>{{ icPriceFormat(parseFloat(item.patch_cost || 0)) }}</strong></td>
                                                                                                        </tr>
                                                                                                    </tbody>
                                                                                                </table>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                class="col-md-5"
                                                                            >
                                                                            <span
                                                                                    class="price_right"
                                                                                >
                                                                                {{
                                                                                    icPriceFormat(
                                                                                        parseFloat(
                                                                                            item.patch_cost ||
                                                                                                0
                                                                                        )
                                                                                    )
                                                                                }}
                                                                            </span>
                                                                            </div>
                                                                            <div
                                                                                class="col-md-2"
                                                                            ></div>
                                                                        </div>

                                                                        <!-- Patch Inventory Saved -->
                                                                        <div
                                                                            class="row color-line"
                                                                            v-if="parseFloat(item.patch_cost || 0) > 0 && item.patch_cost_details && item.patch_cost_details.length > 0 && getPatchInventorySaved(item) > 0"
                                                                        >
                                                                            <div class="col-md-6">
                                                                                <div class="d-flex align-items-center base_product_box_custom">
                                                                                    <div style="color: #1a6e3a;">Patches Saved to Inventory</div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-md-5">
                                                                                <span class="price_right" style="color: #1a6e3a; font-weight: 600;">
                                                                                    {{ getPatchInventorySaved(item) }} patches
                                                                                </span>
                                                                            </div>
                                                                            <div class="col-md-2"></div>
                                                                        </div>

                                                                        <!-- Name & Number Fees -->
                                                                        <div
                                                                            class="row color-line"
                                                                            v-if="
                                                                                item.name_number_fees >
                                                                                0
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="col-md-6"
                                                                            >
                                                                                Name
                                                                                &
                                                                                Number
                                                                                Fees
                                                                            </div>
                                                                            <div
                                                                                class="col-md-5"
                                                                            >
                                                                                {{
                                                                                    icPriceFormat(
                                                                                        parseFloat(
                                                                                            item.name_number_fees ||
                                                                                                0
                                                                                        )
                                                                                    )
                                                                                }}
                                                                            </div>
                                                                            <div
                                                                                class="col-md-2"
                                                                            ></div>
                                                                        </div>

                                                                        <!-- Discounts -->
                                                                        <div
                                                                            class="row color-line"
                                                                            v-if="
                                                                                getItemTotalDiscount(
                                                                                    item
                                                                                ) >
                                                                                0
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="col-md-6"
                                                                            >
                                                                                <div
                                                                                    class="d-flex align-items-center base_product_box_custom"
                                                                                >
                                                                                    <div>
                                                                                        Discount
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                class="col-md-5"
                                                                            >
                                                                                <span
                                                                                    class="price_right discount_value"
                                                                                >
                                                                                    -{{
                                                                                        icPriceFormat(
                                                                                            getItemTotalDiscount(
                                                                                                item
                                                                                            )
                                                                                        )
                                                                                    }}
                                                                                </span>
                                                                            </div>
                                                                            <div
                                                                                class="col-md-2"
                                                                            ></div>
                                                                        </div>

                                                                        <!-- Item Sub Total -->
                                                                        <div
                                                                            class="row color-line item-subtotal-row"
                                                                            v-if="
                                                                                item.item_sub_total !==
                                                                                    null &&
                                                                                item.item_sub_total !==
                                                                                    undefined &&
                                                                                item.item_sub_total !==
                                                                                    ''
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="col-md-6"
                                                                            >
                                                                                <strong
                                                                                    >Item
                                                                                    Sub
                                                                                    Total</strong
                                                                                >
                                                                            </div>
                                                                            <div
                                                                                class="col-md-5"
                                                                            >
                                                                                <strong
                                                                                    >{{
                                                                                        icPriceFormat(
                                                                                            parseFloat(
                                                                                                item.item_sub_total ||
                                                                                                    0
                                                                                            ) -
                                                                                                getItemTotalDiscount(
                                                                                                    item
                                                                                                )
                                                                                        )
                                                                                    }}</strong
                                                                                >
                                                                            </div>
                                                                            <div
                                                                                class="col-md-2"
                                                                            ></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <!-- ARTWORK MODAL -->
                                                            <div
                                                                class="modal fade cart_preview"
                                                                :id="`artworkpreview-${index}`"
                                                                data-backdrop="static"
                                                                data-keyboard="false"
                                                                tabindex="-1"
                                                                aria-labelledby="staticBackdropLabel"
                                                                aria-hidden="true"
                                                            >
                                                                <div
                                                                    class="modal-dialog modal-dialog-centered order_details_art_work_popup_custom"
                                                                >
                                                                    <div
                                                                        class="modal-content"
                                                                    >
                                                                        <div
                                                                            class="modal-header border-bottom-0 py-2 mb_30"
                                                                        >
                                                                            <button
                                                                                type="button"
                                                                                class="close p-0"
                                                                                data-dismiss="modal"
                                                                                aria-label="Close"
                                                                            >
                                                                                <img
                                                                                    src="/images/cancel.svg"
                                                                                />
                                                                            </button>
                                                                        </div>
                                                                        <div
                                                                            class="modal-body pt-0"
                                                                        >
                                                                            <div
                                                                                class="mx-auto preview-image text-center mb_26"
                                                                            >
                                                                                <img
                                                                                    v-if="
                                                                                        item.NewOrderItemDecoration &&
                                                                                        item
                                                                                            .NewOrderItemDecoration
                                                                                            .art_work
                                                                                    "
                                                                                    :src="
                                                                                        item
                                                                                            .NewOrderItemDecoration
                                                                                            .art_work
                                                                                    "
                                                                                    alt=""
                                                                                />
                                                                                <img
                                                                                    v-else-if="
                                                                                        item.front_art_url
                                                                                    "
                                                                                    :src="
                                                                                        item.front_art_url
                                                                                    "
                                                                                    alt=""
                                                                                />
                                                                                <!-- <h3>{{ item.name | capitalize }}</h3> -->
                                                                            </div>
                                                                            <div
                                                                                class="mx-auto preview-image text-center"
                                                                            >
                                                                                <!-- <a  class="btn btn-primary bg-dark" :href="item.NewOrderItemDecoration.art_work">Download</a> -->
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <!-- FINAL PROOF IMAGE MODAL -->
                                                            <div
                                                                class="modal fade cart_preview"
                                                                :id="`finalproofimagepreview-${index}`"
                                                                data-backdrop="static"
                                                                data-keyboard="false"
                                                                tabindex="-1"
                                                                aria-labelledby="staticBackdropLabel"
                                                                aria-hidden="true"
                                                            >
                                                                <div
                                                                    class="modal-dialog modal-dialog-centered order_details_art_work_popup_custom"
                                                                >
                                                                    <div
                                                                        class="modal-content"
                                                                    >
                                                                        <div
                                                                            class="modal-header border-bottom-0 py-2 mb_30"
                                                                        >
                                                                            <button
                                                                                type="button"
                                                                                class="close p-0"
                                                                                data-dismiss="modal"
                                                                                aria-label="Close"
                                                                            >
                                                                                <img
                                                                                    src="/images/cancel.svg"
                                                                                />
                                                                            </button>
                                                                        </div>
                                                                        <div
                                                                            class="modal-body pt-0"
                                                                        >
                                                                            <div
                                                                                class="mx-auto preview-image text-center mb_26"
                                                                            >
                                                                                <img
                                                                                    v-if="
                                                                                        item.NewOrderItemDecoration &&
                                                                                        item
                                                                                            .NewOrderItemDecoration
                                                                                            .final_proof_image
                                                                                    "
                                                                                    :src="
                                                                                        item
                                                                                            .NewOrderItemDecoration
                                                                                            .final_proof_image
                                                                                    "
                                                                                    alt=""
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            v-if="
                                                                order_detail.remarks
                                                            "
                                                            class="col-md-6"
                                                        >
                                                            <div
                                                                class="total-sec-col comment_block"
                                                            >
                                                                <h5>
                                                                    Comments:
                                                                </h5>
                                                                <p>
                                                                    {{
                                                                        order_detail.remarks
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="col-md-6 total_price"
                                                            v-if="!hideTotals"
                                                        >
                                                            <div
                                                                class="row justify-content-end mx-0 cart-total"
                                                            >
                                                                <div
                                                                    class="col-md-4 total-sec-col byaddress-total-col"
                                                                >
                                                                    <div
                                                                        class="p_border border-right-0 base_product_total_box_custom_main_box byaddress-fee-summary"
                                                                    >
                                                                        <div
                                                                            class="product_details"
                                                                        >
                                                                            <div
                                                                                class="row"
                                                                            >
                                                                                <!-- Subtotal -->
                                                                                <div
                                                                                    class="col-md-12"
                                                                                    v-if="!hideTotals"
                                                                                >
                                                                                    <div
                                                                                        class="d-flex justify-content-between align-items-center base_product_total_box_custom byaddress-total-row"
                                                                                    >
                                                                                        <span class="total_p_custom byaddress-label">
                                                                                            <span class="text-nowrap">Subtotal</span>
                                                                                        </span>
                                                                                        <span class="order_no byaddress-value">
                                                                                            {{ icPriceFormat(order_detail.subtotal || 0) }}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                                <!-- Packaging, Kitting and Handling -->
                                                                                <div
                                                                                    class="col-md-12"
                                                                                    v-if="getPackagingTotal() > 0 || (order_detail && order_detail.packaging_cost)"
                                                                                >
                                                                                    <div
                                                                                        class="d-flex justify-content-between align-items-center base_product_total_box_custom kitting_process-items byaddress-total-row"
                                                                                    >
                                                                                        <span class="total_p_custom byaddress-label">
                                                                                            <PendingPaymentTooltip
                                                                                                v-if="getPackagingBreakdown() && getPackagingBreakdown().length > 0"
                                                                                                :label="getRollupFeeDisplayName(5) || 'Packaging, Kitting and Handling'"
                                                                                                :title="(getRollupFeeDisplayName(5) || 'Packaging, Kitting and Handling') + ' Breakdown'"
                                                                                                :breakdown="getPackagingBreakdown()"
                                                                                                :total="getPackagingTotal()"
                                                                                                :format-price="icPriceFormat"
                                                                                            />
                                                                                            <span v-else>{{ getRollupFeeDisplayName(5) || "Packaging, Kitting and Handling" }}</span>
                                                                                        </span>
                                                                                        <span class="order_no byaddress-value">{{ icPriceFormat(getPackagingTotal()) }}</span>
                                                                                    </div>
                                                                                </div>
                                                                                <!-- Shipping and Freight -->
                                                                                <div
                                                                                    class="col-md-12"
                                                                                    v-if="getShippingTotal() > 0"
                                                                                >
                                                                                    <div
                                                                                        class="d-flex justify-content-between align-items-center base_product_total_box_custom kitting_process-items byaddress-total-row"
                                                                                    >
                                                                                        <span class="total_p_custom byaddress-label">
                                                                                            <PendingPaymentTooltip
                                                                                                :label="getRollupFeeDisplayName(4) || 'Shipping And Freight'"
                                                                                                :title="(getRollupFeeDisplayName(4) || 'Shipping And Freight') + ' Breakdown'"
                                                                                                :breakdown="getShippingBreakdown()"
                                                                                                :total="getShippingTotal()"
                                                                                                :format-price="icPriceFormat"
                                                                                            />
                                                                                        </span>
                                                                                        <span class="order_no byaddress-value">{{ icPriceFormat(getShippingTotal()) }}</span>
                                                                                    </div>
                                                                                </div>
                                                                                <!-- Sales Tax -->
                                                                                <div
                                                                                    class="col-md-12"
                                                                                    v-if="getSalesTaxTotal() > 0"
                                                                                >
                                                                                    <div
                                                                                        class="d-flex justify-content-between align-items-center base_product_total_box_custom kitting_process-items byaddress-total-row"
                                                                                    >
                                                                                        <span class="total_p_custom byaddress-label">
                                                                                            <PendingPaymentTooltip
                                                                                                :label="getRollupFeeDisplayName(3) || 'Sales Tax'"
                                                                                                :title="(getRollupFeeDisplayName(3) || 'Sales Tax') + ' Breakdown'"
                                                                                                :breakdown="getSalesTaxBreakdown()"
                                                                                                :total="getSalesTaxTotal()"
                                                                                                :format-price="icPriceFormat"
                                                                                            />
                                                                                        </span>
                                                                                        <span class="order_no byaddress-value">{{ icPriceFormat(getSalesTaxTotal()) }}</span>
                                                                                    </div>
                                                                                </div>
                                                                                <!-- Grand Total -->
                                                                                <div
                                                                                    class="col-md-12 byaddress-item-subtotal-block pt-1"
                                                                                    v-if="!hideTotals"
                                                                                >
                                                                                    <div
                                                                                        class="d-flex justify-content-between align-items-center base_product_total_box_custom byaddress-total-row byaddress-item-subtotal-row"
                                                                                    >
                                                                                        <span class="total_p_custom byaddress-label">
                                                                                            <span class="text-nowrap">Grand Total</span>
                                                                                        </span>
                                                                                        <span class="order_no byaddress-value">{{ icPriceFormat(getGrandTotal()) }}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>
<script>
import ApiService from "@/common/api.service";
import commonData from "@/common/common.data";
import { mapGetters } from "vuex";
import PendingPaymentTooltip from "@/views/frontend/cart_checkout/v3/components/PendingPaymentTooltip.vue";
import { rollupFeeMixin } from "@/common/rollupFee.service";
import ImprintLocationsRow from "./components/ImprintLocationsRow.vue";
import ArtworkPreviewModal from "@/views/frontend/account/components/order-items-by-address/ArtworkPreviewModal.vue";
import NameNumberTable from "@/views/frontend/account/components/order-items-by-address/NameNumberTable.vue";
export default {
    name: "OrderDetails",
    mixins: [rollupFeeMixin],
    props: {
        paymentId: {
            type: [String, Number],
            default: null
        },
        order_data: {
            type: Object,
            default: null
        },
        total_non_standard_colors: {
            type: Array,
            default: () => []
        },
        thankyoupayment: {
            type: Boolean,
            default: false
        },
        paymentAlradyCompleted: {
            type: Boolean,
            default: false
        },
        hideTotals: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            order_detail: null,
            isLoader: false,
            costTooltipVisible: null,
            statuses: commonData.orderStatuses,
            updateOrderStatus: {
                order_id: "",
                order_status: "",
                description: ""
            },
            comment: "",
            order_comments: [],
            decoration_type_list: {
                1: "Print",
                2: "Embroidery",
                3: "Promotional"
            },
            api_url: ApiService.apiUrl(),
            order_fees: [],
            billing_address: {
                first_name: "",
                last_name: "",
                address1: "",
                address2: "",
                city: "",
                state: "",
                country: "",
                zip: "",
                phone: "",
                email: "",
                address_label: ""
            },
            shipping_address: {
                first_name: "",
                last_name: "",
                address1: "",
                address2: "",
                city: "",
                state: "",
                country: "",
                zip: "",
                phone: "",
                email: "",
                address_label: ""
            },
            payment_detail_myJSON: null,
            selectedCanvasLocation: null,
            selectedCanvasModalIndex: null,
            finance_checks_list: [
                "Pending",
                "Finance Approval",
                "Prepaid",
                "Credit Terms",
                "Approved"
            ],
            stock_checks_list: ["Pending", "Approved"],
            finance_check: "",
            stock_check: "",
            additional_payment: null,
            term_payment_details: null,
            card_payment_details: null,
            colors_limit: 6
        };
    },
    mounted() {
        // Use order_data prop if provided, otherwise fetch
        if (this.order_data) {
            this.processOrderData(this.order_data);
        } else if (this.paymentId) {
            this.getOrderDetail();
        }
        this.openCostPopup();
    },
    watch: {
        order_data: {
            handler(newVal) {
                if (newVal) {
                    this.processOrderData(newVal);
                }
            },
            immediate: true,
            deep: true
        }
    },
    components: {
        PendingPaymentTooltip,
        ImprintLocationsRow,
        ArtworkPreviewModal,
        NameNumberTable
    },
    computed: {
        ...mapGetters(["decorationMethods"])
    },
    methods: {
        getOrderItemSizePriceRows(item) {
            const sizes = (item && Array.isArray(item.sizes) ? item.sizes : []) || [];
            return sizes.map((s) => {
                const label = this.getSizeName(s) || "—";
                const qty = parseInt(s && s.quantity, 10) || 0;
                const lineTotal = parseFloat(s && s.total_price) || 0;
                const priceField = parseFloat(s && s.price);
                const unit =
                    !isNaN(priceField) && priceField > 0
                        ? priceField
                        : qty > 0
                            ? lineTotal / qty
                            : 0;
                return { label, qty, unit, lineTotal };
            });
        },
        onImprintOpenCanvasModal(index, locationCode) {
            this.selectedCanvasLocation = locationCode || null;
            this.selectedCanvasModalIndex = index;
            this.$nextTick(() => {
                const sel = "#canvas-images-model-" + index;
                if (window.$ && typeof window.$.fn.modal === "function") {
                    window.$(sel).modal("show");
                }
            });
        },
        onCloseCanvasModal(index) {
            this.selectedCanvasLocation = null;
            this.selectedCanvasModalIndex = null;
            const sel = "#canvas-images-model-" + index;
            if (window.$ && typeof window.$.fn.modal === "function") {
                window.$(sel).modal("hide");
            }
        },
        getDesignImagesFilteredByLocation(designImagesArray, locationCode) {
            if (!locationCode || !Array.isArray(designImagesArray)) {
                return designImagesArray || [];
            }
            const codeToLabel = { F: "front", B: "back", L: "left", R: "right" };
            const label = codeToLabel[locationCode];
            if (!label) return designImagesArray || [];
            return (designImagesArray || []).filter(
                (di) =>
                    di &&
                    di.label &&
                    String(di.label).toLowerCase().trim().indexOf(label) === 0
            );
        },
        getDesignImagesForCanvasModal(item, index) {
            const raw = this.safeParseJSON(item && item.design_images) || [];
            const withCanvas = (raw || []).map((di) => {
                if (
                    di &&
                    (!di.canvas_images || di.canvas_images.length === 0) &&
                    (di.design_image || di.url)
                ) {
                    return Object.assign({}, di, {
                        canvas_images: [
                            {
                                image_path: di.design_image || di.url,
                                image_name: di.label || "",
                                width_inch: null,
                                height_inch: null
                            }
                        ]
                    });
                }
                return di;
            });
            if (this.selectedCanvasModalIndex !== index || !this.selectedCanvasLocation) {
                return withCanvas;
            }
            return this.getDesignImagesFilteredByLocation(withCanvas, this.selectedCanvasLocation);
        },
        getDecorationTypeAbbr(item) {
            if (!item) return "—";
            const name = (this.getDecorationServiceName(item) || "").toLowerCase();
            if (name.indexOf("screen") >= 0 || name.indexOf("print") >= 0) return "SP";
            if (name.indexOf("embroid") >= 0) return "EMB";
            if (name.indexOf("deboss") >= 0) return "DEB";
            if (name.indexOf("heat") >= 0) return "HT";
            if (name.length >= 2) return name.substring(0, 3).toUpperCase();
            return name ? name.toUpperCase() : "—";
        },
        getImprintLocations(item) {
            if (!item) return [];
            const type = this.getDecorationTypeAbbr(item);
            let designImages = [];
            if (item.design_images) {
                try {
                    const parsed =
                        typeof item.design_images === "string"
                            ? JSON.parse(item.design_images)
                            : item.design_images;
                    designImages = Array.isArray(parsed) ? parsed : [];
                } catch (e) {}
            }
            const labelToCode = { front: "F", back: "B", left: "L", right: "R" };
            const order = ["front", "back", "left", "right"];
            const seen = new Set();
            const out = [];
            const fontNameJson = item ? this._getFontSizes(item, "name") : null;
            const fontNumberJson = item ? this._getFontSizes(item, "number") : null;

            designImages.forEach((di) => {
                const label =
                    (di && di.label && String(di.label).toLowerCase().trim()) || "";
                const loc =
                    order.find((o) => label === o || label.indexOf(o) === 0) ||
                    label ||
                    "front";
                const code = labelToCode[loc] || loc.charAt(0).toUpperCase();
                if (seen.has(code)) return;
                seen.add(code);
                let thumb = "";
                if (di && Array.isArray(di.canvas_images) && di.canvas_images.length > 0) {
                    thumb = di.canvas_images[0].image_path || "";
                }
                if (!thumb && di) {
                    thumb = di.design_image || di.url || "";
                }
                let locColors = [];
                if (di && Array.isArray(di.colors) && di.colors.length > 0) {
                    locColors = di.colors;
                } else if (
                    di &&
                    Array.isArray(di.canvas_images) &&
                    di.canvas_images.length > 0 &&
                    Array.isArray(di.canvas_images[0].colors) &&
                    di.canvas_images[0].colors.length > 0
                ) {
                    locColors = di.canvas_images[0].colors;
                }
                if (!locColors.length) {
                    const locationKey =
                        code === "F"
                            ? "front"
                            : code === "B"
                            ? "back"
                            : code === "L"
                            ? "left"
                            : "right";
                    const nameColorHex =
                        fontNameJson &&
                        fontNameJson[locationKey] &&
                        fontNameJson[locationKey].nameFontColor;
                    const numberColorHex =
                        fontNumberJson &&
                        fontNumberJson[locationKey] &&
                        fontNumberJson[locationKey].numberFontColor;
                    const tmp = [];
                    const diLabel = di && di.label;
                    if (nameColorHex && this.hasNameForView(item, diLabel)) {
                        tmp.push({ name: "Name", hex: String(nameColorHex) });
                    }
                    if (numberColorHex && this.hasNumberForView(item, diLabel)) {
                        tmp.push({ name: "Number", hex: String(numberColorHex) });
                    }
                    if (tmp.length) locColors = tmp;
                }
                out.push({
                    code,
                    label: (di && di.label) || loc,
                    thumbnailUrl: thumb,
                    type,
                    colors: locColors
                });
            });
            const dec = item.NewOrderItemDecoration || {};
            if (out.length === 0 && (dec.art_work || item.front_art_url)) {
                out.push({
                    code: "F",
                    label: "Front",
                    thumbnailUrl: dec.art_work || item.front_art_url || "",
                    type,
                    colors: []
                });
            }
            return out;
        },
        getPatchInventorySaved(item) {
            if (!item.patch_cost_details || !Array.isArray(item.patch_cost_details)) return 0;
            const totalQty = parseInt(item.total_quantity || 0, 10);
            let totalSaved = 0;
            for (const d of item.patch_cost_details) {
                const slab = parseInt(d.slab || 0, 10);
                if (slab > totalQty) {
                    totalSaved += (slab - totalQty);
                }
            }
            return totalSaved;
        },
        processOrderData(orderData) {
            // Deep clone to avoid mutating the prop
            this.order_detail = JSON.parse(JSON.stringify(orderData));

            // Parse decoration field for all items if items exist
            if (
                this.order_detail.items &&
                Array.isArray(this.order_detail.items)
            ) {
                this.order_detail.items.forEach((item) => {
                    // Check if decoration exists on the item
                    if (item.decoration) {
                        if (typeof item.decoration === "string") {
                            try {
                                item.decoration = JSON.parse(item.decoration);
                            } catch (e) {
                                item.decoration = null;
                            }
                        }
                    } else {
                        // Try to get decoration from sizes array (for grouped items)
                        if (
                            item.sizes &&
                            Array.isArray(item.sizes) &&
                            item.sizes.length > 0
                        ) {
                            for (let size of item.sizes) {
                                if (size.decoration) {
                                    if (typeof size.decoration === "string") {
                                        try {
                                            item.decoration = JSON.parse(
                                                size.decoration
                                            );
                                            break;
                                        } catch (e) {
                                            // Error parsing decoration
                                        }
                                    } else {
                                        item.decoration = size.decoration;
                                        break;
                                    }
                                }
                            }
                        }
                    }

                    // Ensure NewOrderItemDecoration is set if not already present
                    if (!item.NewOrderItemDecoration) {
                        // Try to get from sizes array (for grouped items)
                        if (
                            item.sizes &&
                            Array.isArray(item.sizes) &&
                            item.sizes.length > 0
                        ) {
                            for (let size of item.sizes) {
                                if (size.NewOrderItemDecoration) {
                                    item.NewOrderItemDecoration =
                                        size.NewOrderItemDecoration;
                                    break;
                                } else if (
                                    size.NewOrderItemDecorations &&
                                    size.NewOrderItemDecorations.length > 0
                                ) {
                                    item.NewOrderItemDecoration =
                                        size.NewOrderItemDecorations[0];
                                    break;
                                }
                            }
                        }
                    }

                    // Keep raw name_and_number_json for location-wise block (hasNameNumberForView). Table uses normalized array.
                    // If item has legacy array but any size has object format (from API), prefer object format so block shows per-view
                    if (item.sizes && Array.isArray(item.sizes) && item.sizes.length > 0 && !this.isNameNumberJsonObjectFormat(item.name_and_number_json)) {
                        for (let s of item.sizes) {
                            if (s.name_and_number_json && this.isNameNumberJsonObjectFormat(s.name_and_number_json)) {
                                item.name_and_number_json = s.name_and_number_json;
                                break;
                            }
                        }
                    }
                    item.name_and_number_json_table = this.normalizeNameAndNumberJson(
                        item.name_and_number_json
                    );
                });
            }
        },
        /** True if value is per-location object format { front, back, left, right }, not legacy array. */
        isNameNumberJsonObjectFormat(val) {
            if (val == null || val === "") return false;
            let p = typeof val === "string" ? (() => { try { return JSON.parse(val); } catch (e) { return null; } })() : val;
            return p && typeof p === "object" && !Array.isArray(p) && ["front", "back", "left", "right"].every((k) => k in p);
        },
        /** Normalize name_and_number_json to array. Supports legacy array and new object { front, back, left, right }. */
        normalizeNameAndNumberJson(raw) {
            if (!raw) {
                return [];
            }
            let parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
            if (Array.isArray(parsed)) {
                // Keep rows that have name, number, or size (lenient so table can show)
                const out = parsed.filter((nn) => {
                    if (!nn || typeof nn !== "object") return false;
                    const hasName =
                        nn.name != null && String(nn.name).trim() !== "";
                    const hasNumber =
                        nn.number != null &&
                        (nn.number === 0 ||
                            nn.number === "0" ||
                            String(nn.number).trim() !== "");
                    const hasSize =
                        nn.size != null && String(nn.size).trim() !== "";
                    return hasName || hasNumber || hasSize;
                });
                return out;
            }
            if (
                parsed &&
                typeof parsed === "object" &&
                !Array.isArray(parsed)
            ) {
                const keys = ["front", "back", "left", "right"];
                let arr = [];
                const firstNonEmpty = keys.find((k) => Array.isArray(parsed[k]) && parsed[k].length > 0);
                if (firstNonEmpty) {
                    arr = parsed[firstNonEmpty];
                } else {
                    keys.forEach((k) => {
                        if (Array.isArray(parsed[k])) arr = arr.concat(parsed[k]);
                    });
                }
                const out = arr.filter((nn) => {
                    if (!nn || typeof nn !== "object") return false;
                    const hasName =
                        nn.name != null && String(nn.name).trim() !== "";
                    const hasNumber =
                        nn.number != null &&
                        (nn.number === 0 ||
                            nn.number === "0" ||
                            String(nn.number).trim() !== "");
                    const hasSize =
                        nn.size != null && String(nn.size).trim() !== "";
                    return hasName || hasNumber || hasSize;
                });
                return out;
            }
            return [];
        },
        existsNameAndNumber(data, type) {
            if (!data || !Array.isArray(data)) {
                return false;
            }
            return data.some(
                (nn) => nn && String(nn[type] || "").trim() !== ""
            );
        },
        // Name/Number Color/Size/Font for display under Front, Back, Left, Right (supports per-location and legacy single)
        _getFontSizes(item, which) {
            const raw =
                which === "name"
                    ? item.font_color_sizes_name
                    : item.font_color_sizes_number;
            if (!raw) return null;
            return typeof raw === "string"
                ? (() => {
                      try {
                          return JSON.parse(raw);
                      } catch (e) {
                          return null;
                      }
                  })()
                : raw;
        },
        _isPerLocationFontSizes(obj) {
            if (!obj || typeof obj !== "object" || Array.isArray(obj)) return false;
            const keys = Object.keys(obj);
            return ["front", "back", "left", "right"].some((k) => keys.includes(k));
        },
        _getFontSizesForLocation(item, which, location) {
            const raw = this._getFontSizes(item, which);
            if (!raw) return null;
            if (location && this._isPerLocationFontSizes(raw)) {
                const locNorm = this.normalizeLocationForNameNumber(location);
                const key = Object.keys(raw).find((k) => this.normalizeLocationForNameNumber(k) === locNorm);
                if (key && raw[key]) return raw[key];
            }
            return raw;
        },
        nameNumberLocations(item) {
            const nameRaw = this._getFontSizes(item, "name");
            const numRaw = this._getFontSizes(item, "number");
            if (this._isPerLocationFontSizes(nameRaw) || this._isPerLocationFontSizes(numRaw)) {
                return ["front", "back", "left", "right"].filter((loc) => (nameRaw && nameRaw[loc]) || (numRaw && numRaw[loc]));
            }
            return ["front"];
        },
        getLocationLabel(loc) {
            return loc ? loc.charAt(0).toUpperCase() + loc.slice(1) : "";
        },
        /** Normalize design_img label to standard key: "Front"/"Front View" -> "front", "Left"/"Left Side" -> "left". */
        normalizeLocationForNameNumber(location) {
            const s = (location || "").toString().toLowerCase().trim();
            const standard = ["front", "back", "left", "right"];
            const found = standard.find((k) => s === k || s.indexOf(k) === 0);
            return found || s;
        },
        /** selected_name_number lives inside name_and_number_json (no extra column). Parse if string. */
        getSelectedNameNumber(item) {
            if (!item || item.name_and_number_json == null) return {};
            let nn = item.name_and_number_json;
            if (typeof nn === "string") {
                try {
                    nn = JSON.parse(nn) || {};
                } catch (e) {
                    return {};
                }
            }
            return (nn && nn.selected_name_number) || {};
        },
        /** True only when this item has name/number for this view. Location-wise; keys case-insensitive. Respects selected_name_number – if both name and number are off for this location, do not show. */
        hasNameNumberForView(item, location) {
            if (!item) return false;
            const loc = this.normalizeLocationForNameNumber(location || "");
            if (!loc) return false;
            const snn = this.getSelectedNameNumber(item);
            const locSel = snn[loc];
            const hasSelectionData = snn && typeof snn === "object" && Object.keys(snn).length > 0;
            if (hasSelectionData && (!locSel || (locSel.name !== true && locSel.number !== true))) {
                return false;
            }
            let nn = item.name_and_number_json;
            if (!nn && item.sizes && Array.isArray(item.sizes) && item.sizes.length > 0) {
                for (let s of item.sizes) {
                    if (s.name_and_number_json) { nn = s.name_and_number_json; break; }
                }
            }
            if (typeof nn === "string") {
                try { nn = JSON.parse(nn); } catch (e) { nn = null; }
            }
            let result = false;
            if (nn && typeof nn === "object" && !Array.isArray(nn)) {
                const key = Object.keys(nn).find((k) => this.normalizeLocationForNameNumber(k) === loc) || loc;
                const arr = Array.isArray(nn[key]) ? nn[key] : [];
                result = arr.some((e) => e && (String(e.name || "").trim() !== "" || String(e.number != null ? e.number : "").trim() !== ""));
            } else if (nn && Array.isArray(nn) && nn.length > 0 && (this.existsNameAndNumber(nn, "name") || this.existsNameAndNumber(nn, "number"))) {
                result = true;
            }
            return result;
        },
        /** True if this location has name enabled and at least one non-empty name. */
        hasNameForView(item, location) {
            if (!item) return false;
            const loc = this.normalizeLocationForNameNumber(location || "");
            if (!loc) return false;
            const snn = this.getSelectedNameNumber(item);
            const locSel = snn[loc];
            if (locSel && locSel.name === false) return false;
            let nn = item.name_and_number_json;
            if (!nn && item.sizes && Array.isArray(item.sizes) && item.sizes.length > 0) {
                for (let s of item.sizes) {
                    if (s.name_and_number_json) { nn = s.name_and_number_json; break; }
                }
            }
            if (typeof nn === "string") {
                try { nn = JSON.parse(nn); } catch (e) { nn = null; }
            }
            if (nn && typeof nn === "object" && !Array.isArray(nn)) {
                const key = Object.keys(nn).find((k) => this.normalizeLocationForNameNumber(k) === loc) || loc;
                const arr = Array.isArray(nn[key]) ? nn[key] : [];
                return arr.some((e) => e && String(e.name || "").trim() !== "");
            }
            if (nn && Array.isArray(nn)) return this.existsNameAndNumber(nn, "name");
            return false;
        },
        /** True if this location has number enabled and at least one non-empty number. */
        hasNumberForView(item, location) {
            if (!item) return false;
            const loc = this.normalizeLocationForNameNumber(location || "");
            if (!loc) return false;
            const snn = this.getSelectedNameNumber(item);
            const locSel = snn[loc];
            if (locSel && locSel.number === false) return false;
            let nn = item.name_and_number_json;
            if (!nn && item.sizes && Array.isArray(item.sizes) && item.sizes.length > 0) {
                for (let s of item.sizes) {
                    if (s.name_and_number_json) { nn = s.name_and_number_json; break; }
                }
            }
            if (typeof nn === "string") {
                try { nn = JSON.parse(nn); } catch (e) { nn = null; }
            }
            if (nn && typeof nn === "object" && !Array.isArray(nn)) {
                const key = Object.keys(nn).find((k) => this.normalizeLocationForNameNumber(k) === loc) || loc;
                const arr = Array.isArray(nn[key]) ? nn[key] : [];
                return arr.some((e) => e && (e.number != null && (e.number === 0 || e.number === "0" || String(e.number).trim() !== "")));
            }
            if (nn && Array.isArray(nn)) return this.existsNameAndNumber(nn, "number");
            return false;
        },
        // Dimension text (Imprint Area): match admin - label match + support widthIn/heightIn or width_inch/height_inch
        matchDimensionLabel(designImgLabel, designInches) {
            if (!designInches) return false;
            const rawInch = (designInches.label != null ? designInches.label : designInches.label_show != null ? designInches.label_show : "").toString().trim();
            if (!rawInch) return false;
            const imgLabel = (designImgLabel || "").toString().trim().replace(/(?:^|\s|-)\S/g, (x) => x.toUpperCase());
            const inchLabel = rawInch;
            return imgLabel === inchLabel || imgLabel.toLowerCase() === inchLabel.toLowerCase();
        },
        hasDimensionInches(designInches) {
            return designInches && ("widthIn" in designInches || "width_inch" in designInches);
        },
        getDimensionWidth(designInches) {
            if (!designInches) return "";
            return designInches.widthIn != null ? designInches.widthIn : (designInches.width_inch != null ? designInches.width_inch : "");
        },
        getDimensionHeight(designInches) {
            if (!designInches) return "";
            return designInches.heightIn != null ? designInches.heightIn : (designInches.height_inch != null ? designInches.height_inch : "");
        },
        getNameNumberColor(item, key, location) {
            const first =
                item.name_and_number_json && item.name_and_number_json[0]
                    ? item.name_and_number_json[0][key]
                    : null;
            if (first != null && first !== "") return first;
            const nameObj = this._getFontSizesForLocation(item, "name", location);
            const numObj = this._getFontSizesForLocation(item, "number", location);
            if (key === "nameColor" && nameObj) return nameObj.nameFontColor;
            if (key === "numberColor" && numObj) return numObj.numberFontColor;
            return null;
        },
        getNameNumberSize(item, key, location) {
            const first =
                item.name_and_number_json && item.name_and_number_json[0]
                    ? item.name_and_number_json[0][key]
                    : null;
            if (first != null && first !== "") return first;
            const nameObj = this._getFontSizesForLocation(item, "name", location);
            const numObj = this._getFontSizesForLocation(item, "number", location);
            if (key === "nameSize" && nameObj) return nameObj.nameFontSize;
            if (key === "numberSize" && numObj) return numObj.numberFontSize;
            return null;
        },
        getNameNumberFont(item, key, location) {
            const first =
                item.name_and_number_json && item.name_and_number_json[0]
                    ? item.name_and_number_json[0][key]
                    : null;
            if (first != null && first !== "") return first;
            const nameObj = this._getFontSizesForLocation(item, "name", location);
            const numObj = this._getFontSizesForLocation(item, "number", location);
            if (key === "nameFont" && nameObj) return nameObj.nameFontFamily;
            if (key === "numberFont" && numObj) return numObj.numberFontFamily;
            return null;
        },

        getOrderDetail() {
            this.isLoader = true;
            new Promise((resolve) => {
                ApiService.get("/neworderdetailbypendingid/" + this.paymentId)
                    .then(({ data }) => {
                        this.order_detail = data.order;
                        let order_items = [];
                        let all_setup_fee = 0;
                        let subtotal = 0;
                        let front_art_url;
                        let total_non_standard_colors = [];
                        data.order.NewOrderItems.forEach((item) => {
                            // Check for new structure first (MainNewSubProduct)
                            if (
                                item.MainNewSubProduct &&
                                item.MainNewSubProduct.MainNewProducts
                            ) {
                                let item_setup_fee = 0;
                                let color_fee = 0;
                                // Create a copy of MainNewProducts to preserve all properties
                                let order_item = {
                                    ...item.MainNewSubProduct.MainNewProducts
                                };
                                // Ensure name and other essential properties are preserved
                                order_item.name =
                                    item.MainNewSubProduct.MainNewProducts
                                        .name ||
                                    item.MainNewSubProduct.MainNewProducts
                                        .product_number ||
                                    "Product";
                                order_item.id =
                                    item.MainNewSubProduct.MainNewProducts.id;
                                order_item.product_number =
                                    item.MainNewSubProduct.MainNewProducts.product_number;
                                order_item.Category =
                                    item.MainNewSubProduct.MainNewProducts.Category;
                                order_item.Vendor =
                                    (item.MainNewSubProduct.MainNewProducts && item.MainNewSubProduct.MainNewProducts.Vendor) ||
                                    (item.MainNewSubProduct.MainNewProduct && item.MainNewSubProduct.MainNewProduct.Vendor) ||
                                    null;
                                order_item.gender_size_id = item.gender_size_id;
                                order_item.unique_item_id = item.unique_item_id;
                                order_item.color = item.MainNewSubProduct.Color;
                                // Handle NewOrderItemDecoration - can be single object or array
                                if (item.NewOrderItemDecoration) {
                                    // If it's already a single object, use it directly
                                    if (
                                        typeof item.NewOrderItemDecoration ===
                                            "object" &&
                                        !Array.isArray(
                                            item.NewOrderItemDecoration
                                        )
                                    ) {
                                        order_item["NewOrderItemDecoration"] =
                                            item.NewOrderItemDecoration;
                                    } else if (
                                        Array.isArray(
                                            item.NewOrderItemDecoration
                                        ) &&
                                        item.NewOrderItemDecoration.length > 0
                                    ) {
                                        order_item["NewOrderItemDecoration"] =
                                            item.NewOrderItemDecoration[0];
                                    } else {
                                        order_item["NewOrderItemDecoration"] =
                                            null;
                                    }
                                } else if (
                                    item.NewOrderItemDecorations &&
                                    item.NewOrderItemDecorations.length > 0
                                ) {
                                    // Fallback to NewOrderItemDecorations (plural) array
                                    order_item["NewOrderItemDecoration"] =
                                        item.NewOrderItemDecorations[0];
                                } else {
                                    order_item["NewOrderItemDecoration"] = null;
                                }
                                let index = order_items.findIndex(
                                    (item_data) =>
                                        item_data.id ==
                                            item.MainNewSubProduct
                                                .parent_product_id &&
                                        item_data.color.id ==
                                            item.MainNewSubProduct.color_id &&
                                        item_data.gender_size_id ==
                                            item.gender_size_id &&
                                        item_data.unique_item_id ==
                                            item.unique_item_id
                                );
                                item_setup_fee =
                                    item_setup_fee + parseFloat(item.setup_fee);
                                // Subtotal will be calculated from item_sub_total after grouping
                                if (index >= 0 && order_items[index]) {
                                    // Copy estimated_shipping_date from first size (parent = 1) if not already set
                                    if (
                                        !order_items[index][
                                            "estimated_shipping_date"
                                        ] &&
                                        item.estimated_shipping_date &&
                                        item.parent === 1
                                    ) {
                                        order_items[index][
                                            "estimated_shipping_date"
                                        ] = item.estimated_shipping_date;
                                    }
                                    const hasIncoming = item.name_and_number_json != null && item.name_and_number_json !== "";
                                    const current = order_items[index].name_and_number_json;
                                    const currentEmpty = current == null || current === "";
                                    const incomingIsObject = this.isNameNumberJsonObjectFormat(item.name_and_number_json);
                                    const currentIsLegacy = current && !this.isNameNumberJsonObjectFormat(current);
                                    if (hasIncoming && (currentEmpty || (currentIsLegacy && incomingIsObject))) {
                                        order_items[index]["name_and_number_json"] = item.name_and_number_json;
                                        order_items[index]["name_and_number_json_table"] = this.normalizeNameAndNumberJson(item.name_and_number_json);
                                    }
                                    order_items[index]["sizes"].push(item);
                                    order_items[index]["total_quantity"] +=
                                        item.quantity;
                                    order_items[index]["total_price"] +=
                                        parseFloat(item.total_price) +
                                        parseFloat(item.discount);
                                    order_items[index]["total_discount"] +=
                                        parseFloat(item.discount);
                                    // For grouped items, sum item_sub_total from all sizes
                                    if (item.item_sub_total) {
                                        if (
                                            !order_items[index][
                                                "item_sub_total"
                                            ]
                                        ) {
                                            order_items[index][
                                                "item_sub_total"
                                            ] = 0;
                                        }
                                        order_items[index]["item_sub_total"] +=
                                            parseFloat(
                                                item.item_sub_total || 0
                                            );
                                    }
                                    // Copy breakdown fields from first size if not already set (always parse as JSON string like admin)
                                    if (
                                        !order_items[index]["base_fee"] &&
                                        item.base_fee
                                    ) {
                                        order_items[index]["base_fee"] =
                                            typeof item.base_fee === "string"
                                                ? JSON.parse(item.base_fee)
                                                : item.base_fee;
                                    }
                                    if (
                                        !order_items[index][
                                            "run_charge_breakdown"
                                        ] &&
                                        item.run_charge_breakdown
                                    ) {
                                        order_items[index][
                                            "run_charge_breakdown"
                                        ] =
                                            typeof item.run_charge_breakdown ===
                                            "string"
                                                ? JSON.parse(
                                                      item.run_charge_breakdown
                                                  )
                                                : item.run_charge_breakdown;
                                    }
                                    if (
                                        !order_items[index][
                                            "rush_fee_breakdown"
                                        ] &&
                                        item.rush_fee_breakdown
                                    ) {
                                        order_items[index][
                                            "rush_fee_breakdown"
                                        ] =
                                            typeof item.rush_fee_breakdown ===
                                            "string"
                                                ? JSON.parse(
                                                      item.rush_fee_breakdown
                                                  )
                                                : item.rush_fee_breakdown;
                                    }
                                    // Copy estimated_shipping_date from first size (parent = 1) if not already set
                                    if (
                                        !order_items[index][
                                            "estimated_shipping_date"
                                        ] &&
                                        item.estimated_shipping_date
                                    ) {
                                        order_items[index][
                                            "estimated_shipping_date"
                                        ] = item.estimated_shipping_date;
                                    }
                                    if (
                                        !order_items[index][
                                            "setup_fees_details"
                                        ] &&
                                        item.setup_fees_details
                                    ) {
                                        order_items[index][
                                            "setup_fees_details"
                                        ] =
                                            typeof item.setup_fees_details ===
                                            "string"
                                                ? JSON.parse(
                                                      item.setup_fees_details
                                                  )
                                                : item.setup_fees_details;
                                    }
                                    if (
                                        !order_items[index][
                                            "custom_color_fee"
                                        ] &&
                                        item.custom_color_fee
                                    ) {
                                        order_items[index]["custom_color_fee"] =
                                            typeof item.custom_color_fee ===
                                            "string"
                                                ? JSON.parse(
                                                      item.custom_color_fee
                                                  )
                                                : item.custom_color_fee;
                                    }
                                    // Parse decoration field for grouped items
                                    if (
                                        !order_items[index]["decoration"] &&
                                        item.decoration
                                    ) {
                                        order_items[index]["decoration"] =
                                            item.decoration
                                                ? typeof item.decoration ===
                                                  "string"
                                                    ? JSON.parse(
                                                          item.decoration
                                                      )
                                                    : item.decoration
                                                : null;
                                    }
                                    // Copy NewOrderItemDecoration for grouped items if not already set
                                    if (
                                        !order_items[index][
                                            "NewOrderItemDecoration"
                                        ]
                                    ) {
                                        // Try to get from item.NewOrderItemDecoration (single object)
                                        if (item.NewOrderItemDecoration) {
                                            if (
                                                typeof item.NewOrderItemDecoration ===
                                                    "object" &&
                                                !Array.isArray(
                                                    item.NewOrderItemDecoration
                                                )
                                            ) {
                                                order_items[index][
                                                    "NewOrderItemDecoration"
                                                ] = item.NewOrderItemDecoration;
                                            } else if (
                                                Array.isArray(
                                                    item.NewOrderItemDecoration
                                                ) &&
                                                item.NewOrderItemDecoration
                                                    .length > 0
                                            ) {
                                                order_items[index][
                                                    "NewOrderItemDecoration"
                                                ] =
                                                    item.NewOrderItemDecoration[0];
                                            }
                                        } else if (
                                            item.NewOrderItemDecorations &&
                                            item.NewOrderItemDecorations
                                                .length > 0
                                        ) {
                                            // Fallback to NewOrderItemDecorations (plural) array
                                            order_items[index][
                                                "NewOrderItemDecoration"
                                            ] = item.NewOrderItemDecorations[0];
                                        }
                                    }
                                    // Copy patch cost for display (from first size in group)
                                    if (
                                        !order_items[index][
                                            "patch_cost_details"
                                        ] &&
                                        item.patch_cost_details
                                    ) {
                                        order_items[index][
                                            "patch_cost_details"
                                        ] =
                                            typeof item.patch_cost_details ===
                                            "string"
                                                ? JSON.parse(
                                                      item.patch_cost_details
                                                  )
                                                : item.patch_cost_details;
                                    }
                                    if (
                                        !order_items[index]["patch_cost"] &&
                                        parseFloat(item.patch_cost || 0) > 0
                                    ) {
                                        order_items[index]["patch_cost"] =
                                            parseFloat(item.patch_cost || 0);
                                    }
                                    // Copy name/number font for display (from first size in group)
                                    if (
                                        !order_items[index][
                                            "font_color_sizes_name"
                                        ] &&
                                        item.font_color_sizes_name
                                    ) {
                                        order_items[index][
                                            "font_color_sizes_name"
                                        ] = item.font_color_sizes_name;
                                    }
                                    if (
                                        !order_items[index][
                                            "font_color_sizes_number"
                                        ] &&
                                        item.font_color_sizes_number
                                    ) {
                                        order_items[index][
                                            "font_color_sizes_number"
                                        ] = item.font_color_sizes_number;
                                    }
                                } else {
                                    order_item["sizes"] = [item];
                                    order_item["total_quantity"] =
                                        item.quantity;
                                    order_item["setup_fee"] = item_setup_fee;
                                    order_item["total_price"] =
                                        parseFloat(item.total_price) +
                                        parseFloat(item.discount);
                                    order_item["total_discount"] = parseFloat(
                                        item.discount
                                    );
                                    order_item["design_fee"] = parseFloat(
                                        item.design_fee
                                    );
                                    order_item["patch_cost"] = parseFloat(
                                        item.patch_cost || 0
                                    );
                                    order_item["patch_cost_details"] = item.patch_cost_details
                                        ? (typeof item.patch_cost_details === "string"
                                            ? JSON.parse(item.patch_cost_details)
                                            : item.patch_cost_details)
                                        : null;
                                    order_item["name_number_fees"] = parseFloat(
                                        item.name_number_fees
                                    );
                                    order_item["non_standard_fees"] =
                                        parseFloat(item.non_standard_fees);
                                    order_item["item_sub_total"] =
                                        item.item_sub_total
                                            ? parseFloat(item.item_sub_total)
                                            : null;
                                    // Copy breakdown fields from item to order_item (always parse as JSON string like admin)
                                    order_item["base_fee"] = item.base_fee
                                        ? typeof item.base_fee === "string"
                                            ? JSON.parse(item.base_fee)
                                            : item.base_fee
                                        : [];
                                    order_item["run_charge_breakdown"] =
                                        item.run_charge_breakdown
                                            ? typeof item.run_charge_breakdown ===
                                              "string"
                                                ? JSON.parse(
                                                      item.run_charge_breakdown
                                                  )
                                                : item.run_charge_breakdown
                                            : [];
                                    order_item["rush_fee_breakdown"] =
                                        item.rush_fee_breakdown
                                            ? typeof item.rush_fee_breakdown ===
                                              "string"
                                                ? JSON.parse(
                                                      item.rush_fee_breakdown
                                                  )
                                                : item.rush_fee_breakdown
                                            : null;
                                    // Copy estimated_shipping_date from item if parent = 1
                                    if (
                                        item.estimated_shipping_date &&
                                        item.parent === 1
                                    ) {
                                        order_item["estimated_shipping_date"] =
                                            item.estimated_shipping_date;
                                    }
                                    order_item["setup_fees_details"] =
                                        item.setup_fees_details
                                            ? typeof item.setup_fees_details ===
                                              "string"
                                                ? JSON.parse(
                                                      item.setup_fees_details
                                                  )
                                                : item.setup_fees_details
                                            : null;
                                    order_item["custom_color_fee"] =
                                        item.custom_color_fee
                                            ? typeof item.custom_color_fee ===
                                              "string"
                                                ? JSON.parse(
                                                      item.custom_color_fee
                                                  )
                                                : item.custom_color_fee
                                            : [];
                                    order_item["non_standard_colors"] =
                                        item.non_standard_colors
                                            ? typeof item.non_standard_colors ===
                                              "string"
                                                ? JSON.parse(
                                                      item.non_standard_colors
                                                  )
                                                : item.non_standard_colors
                                            : [];
                                    order_item["decoration_colors"] =
                                        item.decoration_colors
                                            ? typeof item.decoration_colors ===
                                              "string"
                                                ? JSON.parse(
                                                      item.decoration_colors
                                                  )
                                                : item.decoration_colors
                                            : [];
                                    // Parse decoration field
                                    order_item["decoration"] = item.decoration
                                        ? typeof item.decoration === "string"
                                            ? JSON.parse(item.decoration)
                                            : item.decoration
                                        : null;
                                    // Set NewOrderItemDecoration for non-grouped items
                                    if (!order_item["NewOrderItemDecoration"]) {
                                        // Try to get from item.NewOrderItemDecoration (single object)
                                        if (item.NewOrderItemDecoration) {
                                            if (
                                                typeof item.NewOrderItemDecoration ===
                                                    "object" &&
                                                !Array.isArray(
                                                    item.NewOrderItemDecoration
                                                )
                                            ) {
                                                order_item[
                                                    "NewOrderItemDecoration"
                                                ] = item.NewOrderItemDecoration;
                                            } else if (
                                                Array.isArray(
                                                    item.NewOrderItemDecoration
                                                ) &&
                                                item.NewOrderItemDecoration
                                                    .length > 0
                                            ) {
                                                order_item[
                                                    "NewOrderItemDecoration"
                                                ] =
                                                    item.NewOrderItemDecoration[0];
                                            }
                                        } else if (
                                            item.NewOrderItemDecorations &&
                                            item.NewOrderItemDecorations
                                                .length > 0
                                        ) {
                                            // Fallback to NewOrderItemDecorations (plural) array
                                            order_item[
                                                "NewOrderItemDecoration"
                                            ] = item.NewOrderItemDecorations[0];
                                        }
                                    }
                                    total_non_standard_colors =
                                        total_non_standard_colors.concat(
                                            order_item["non_standard_colors"]
                                        );
                                    order_item["imprint_locations"] =
                                        item.imprint_locations
                                            ? typeof item.imprint_locations ===
                                              "string"
                                                ? JSON.parse(
                                                      item.imprint_locations
                                                  )
                                                : item.imprint_locations
                                            : [];
                                    order_item["imprint_locations"] =
                                        order_item["imprint_locations"].filter(
                                            (imprint_location) =>
                                                imprint_location.is_selected
                                        );
                                    order_item["color_fee"] = 0;
                                    // Get product images from MainNewProductImages
                                    const productImages =
                                        item.MainNewSubProduct.MainNewProducts
                                            .MainNewProductImages || [];
                                    order_item["product_image"] =
                                        productImages.find(
                                            (image) =>
                                                image.color_id ==
                                                order_item.color.id
                                        );
                                    if (
                                        !order_item["product_image"] &&
                                        productImages.length > 0
                                    ) {
                                        order_item["product_image"] =
                                            productImages[0];
                                    }
                                    // Also set MainNewProductImages for compatibility
                                    order_item["MainNewProductImages"] =
                                        productImages;
                                    order_item["build_id"] = item.build_id;
                                    order_item["design_images"] =
                                        item.design_image
                                            ? typeof item.design_image ===
                                              "string"
                                                ? JSON.parse(item.design_image)
                                                : item.design_image
                                            : [];
                                    if (
                                        order_item["design_images"] &&
                                        order_item["design_images"].length > 0
                                    ) {
                                        order_item["design_image"] =
                                            order_item["design_images"][0][
                                                "url"
                                            ];
                                        if (
                                            front_art_url !=
                                            order_item["design_images"][0][
                                                "design_image"
                                            ]
                                        ) {
                                            order_item["front_art_url"] =
                                                order_item["design_images"][0][
                                                    "design_image"
                                                ];
                                            front_art_url =
                                                order_item["front_art_url"];
                                        }
                                        if (item.OrderBuild) {
                                            order_item["OrderBuild"] =
                                                item.OrderBuild;
                                        }
                                    }
                                    order_item["name_and_number_json"] = item.name_and_number_json;
                                    order_item["name_and_number_json_table"] = this.normalizeNameAndNumberJson(item.name_and_number_json);
                                                    // Name/Number Color, Size, Font display (from main_new_order_items)
                                    order_item["font_color_sizes_name"] =
                                        item.font_color_sizes_name != null &&
                                        item.font_color_sizes_name !== ""
                                            ? item.font_color_sizes_name
                                            : null;
                                    order_item["font_color_sizes_number"] =
                                        item.font_color_sizes_number != null &&
                                        item.font_color_sizes_number !== ""
                                            ? item.font_color_sizes_number
                                            : null;
                                    order_item["imprint_locations"].forEach(
                                        (location) => {
                                            order_item["color_fee"] +=
                                                parseFloat(
                                                    location[
                                                        "total_decoration_fee"
                                                    ]
                                                );
                                            color_fee =
                                                color_fee +
                                                parseFloat(
                                                    location[
                                                        "total_decoration_fee"
                                                    ]
                                                );
                                            if (location.is_selected) {
                                                location.colors.forEach(
                                                    (color) => {
                                                        order_item[
                                                            "color_fee"
                                                        ] += parseFloat(
                                                            color.total_decor_upcharge
                                                        );
                                                        color_fee =
                                                            color_fee +
                                                            parseFloat(
                                                                color.total_decor_upcharge
                                                            );
                                                    }
                                                );
                                            }
                                        }
                                    );
                                    order_item["total_single_location_price"] =
                                        parseFloat(
                                            item["single_location_price"]
                                        ) * parseFloat(item["quantity"]);
                                    order_item["total_extra_fees"] =
                                        parseFloat(
                                            item["single_location_price"]
                                        ) * parseFloat(item["quantity"]);
                                    order_items.push(order_item);
                                }
                                all_setup_fee += item_setup_fee;
                                all_color_fee += color_fee;
                            }
                            // Fallback to old structure (NewSubProduct)
                            else if (item.NewSubProduct) {
                                let item_setup_fee = 0;
                                let order_item = item.NewSubProduct.NewProduct;
                                order_item.gender_size_id = item.gender_size_id;
                                order_item.unique_item_id = item.unique_item_id;
                                order_item.color = item.NewSubProduct.Color;
                                order_item["NewOrderItemDecoration"] =
                                    item.NewOrderItemDecoration;
                                let index = order_items.findIndex(
                                    (item_data) =>
                                        item_data.id ==
                                            item.NewSubProduct
                                                .parent_product_id &&
                                        item_data.color.id ==
                                            item.NewSubProduct.color_id &&
                                        item_data.gender_size_id ==
                                            item.gender_size_id &&
                                        item_data.unique_item_id ==
                                            item.unique_item_id
                                );
                                item_setup_fee =
                                    item_setup_fee + parseFloat(item.setup_fee);
                                subtotal =
                                    subtotal +
                                    parseFloat(item.total_price) +
                                    parseFloat(item.design_fee) +
                                    parseFloat(item.setup_fee) +
                                    parseFloat(item.non_standard_fees) +
                                    parseFloat(item.name_number_fees);
                                if (index >= 0 && order_items[index]) {
                                    const hasIncomingNn = item.name_and_number_json != null && item.name_and_number_json !== "";
                                    const curNn = order_items[index].name_and_number_json;
                                    const curNnEmpty = curNn == null || curNn === "";
                                    const inNnObject = this.isNameNumberJsonObjectFormat(item.name_and_number_json);
                                    const curNnLegacy = curNn && !this.isNameNumberJsonObjectFormat(curNn);
                                    if (hasIncomingNn && (curNnEmpty || (curNnLegacy && inNnObject))) {
                                        order_items[index]["name_and_number_json"] = item.name_and_number_json;
                                        order_items[index]["name_and_number_json_table"] = this.normalizeNameAndNumberJson(item.name_and_number_json);
                                    }
                                    order_items[index]["sizes"].push(item);
                                    order_items[index]["total_quantity"] +=
                                        item.quantity;
                                    order_items[index]["total_price"] +=
                                        parseFloat(item.total_price) +
                                        parseFloat(item.discount);
                                } else {
                                    order_item["sizes"] = [item];
                                    order_item["total_quantity"] =
                                        item.quantity;

                                    order_item["setup_fee"] = item_setup_fee;
                                    order_item["design_fee"] = parseFloat(
                                        item.design_fee
                                    );
                                    order_item["name_number_fees"] = parseFloat(
                                        item.name_number_fees
                                    );
                                    order_item["non_standard_fees"] =
                                        parseFloat(item.non_standard_fees);
                                    order_item["non_standard_colors"] =
                                        item.non_standard_colors
                                            ? JSON.parse(
                                                  item.non_standard_colors
                                              )
                                            : [];
                                    order_item["standard_colors"] =
                                        item.standard_colors
                                            ? JSON.parse(item.standard_colors)
                                            : [];
                                    order_item["decoration_colors"] =
                                        item.decoration_colors
                                            ? JSON.parse(item.decoration_colors)
                                            : [];
                                    //order_item.artwork_colors = [...new Set(order_item.standard_colors.concat(order_item.non_standard_colors))];
                                    total_non_standard_colors =
                                        total_non_standard_colors.concat(
                                            order_item["non_standard_colors"]
                                        );
                                    order_item["imprint_locations"] =
                                        item.imprint_locations
                                            ? JSON.parse(item.imprint_locations)
                                            : [];
                                    if (order_item["imprint_locations"]) {
                                        order_item["imprint_locations"] =
                                            order_item[
                                                "imprint_locations"
                                            ].filter(
                                                (imprint_location) =>
                                                    imprint_location.is_selected
                                            );
                                    }
                                    // order_item['design_image'] = JSON.parse(item.design_image)[0]['url'];
                                    // order_item['design_images'] = item.design_image;
                                    order_item["name_and_number_json"] = item.name_and_number_json;
                                    order_item["name_and_number_json_table"] = this.normalizeNameAndNumberJson(item.name_and_number_json);
                                    order_item["font_color_sizes_name"] =
                                        item.font_color_sizes_name
                                            ? JSON.parse(
                                                  item.font_color_sizes_name
                                              )
                                            : [];
                                    order_item["font_color_sizes_number"] =
                                        item.font_color_sizes_number
                                            ? JSON.parse(
                                                  item.font_color_sizes_number
                                              )
                                            : [];
                                    order_item["total_dark_category_fee"] =
                                        parseFloat(
                                            item.total_dark_category_fee
                                        );
                                    order_item["total_light_category_fee"] =
                                        parseFloat(
                                            item.total_light_category_fee
                                        );
                                    order_item["product_image"] =
                                        order_item.NewProductImages.find(
                                            (image) =>
                                                image.color_id ==
                                                order_item.color.id
                                        );
                                    if (!order_item["product_image"]) {
                                        order_item["product_image"] =
                                            order_item.NewProductImages[0];
                                    }
                                    order_item["color_fee"] = 0;
                                    order_item["build_id"] = item.build_id;
                                    order_item["design_area_inches"] =
                                        item.design_area_inches;
                                    order_item["design_images"] =
                                        item.design_image;
                                    if (
                                        order_item["design_images"] &&
                                        order_item["design_images"].length > 0
                                    ) {
                                        order_item["design_image"] = JSON.parse(
                                            item.design_image
                                        )[0]["url"];
                                        order_item["image_url"] = JSON.parse(
                                            order_item["design_images"]
                                        ).filter(
                                            (image) => image.label == "back"
                                        );
                                        if (
                                            front_art_url !=
                                            JSON.parse(item.design_image)[0][
                                                "design_image"
                                            ]
                                        ) {
                                            order_item["front_art_url"] =
                                                JSON.parse(
                                                    item.design_image
                                                )[0]["design_image"];
                                            front_art_url =
                                                order_item["front_art_url"];
                                        }

                                        if (item.OrderBuild) {
                                            order_item["OrderBuild"] =
                                                item.OrderBuild;
                                        }
                                    }

                                    (order_item["name_and_number_json_table"] || []).forEach(
                                        (nameandnumber) => {
                                            nameandnumber.unique_order_id =
                                                item.NewOrderItemDecoration
                                                    ? item
                                                          .NewOrderItemDecoration
                                                          .unique_order_id
                                                    : null;
                                            nameandnumber.product_number =
                                                item.NewSubProduct
                                                    ? item.NewSubProduct.name
                                                    : "";
                                            nameandnumber.t_shirt_color =
                                                order_item.color.name;
                                            nameandnumber.nameFont =
                                                order_item[
                                                    "font_color_sizes_name"
                                                ].nameFontFamily;
                                            nameandnumber.nameColor =
                                                order_item[
                                                    "font_color_sizes_name"
                                                ].nameFontColor;
                                            nameandnumber.nameSize =
                                                order_item[
                                                    "font_color_sizes_name"
                                                ].nameFontSize;
                                            nameandnumber.numberFont =
                                                order_item[
                                                    "font_color_sizes_number"
                                                ].numberFontFamily;
                                            nameandnumber.numberColor =
                                                order_item[
                                                    "font_color_sizes_number"
                                                ].numberFontColor;
                                            nameandnumber.numberSize =
                                                order_item[
                                                    "font_color_sizes_number"
                                                ].numberFontSize;
                                            nameandnumber.image_url =
                                                order_item["image_url"] &&
                                                order_item["image_url"][0] !==
                                                    undefined
                                                    ? order_item["image_url"][0]
                                                          .url
                                                    : "";
                                        }
                                    );

                                    if (order_item["imprint_locations"]) {
                                        order_item["imprint_locations"].forEach(
                                            (location) => {
                                                order_item["color_fee"] +=
                                                    parseFloat(
                                                        location[
                                                            "total_decoration_fee"
                                                        ]
                                                    );
                                                if (location.is_selected) {
                                                    location.colors.forEach(
                                                        (color) => {
                                                            // if (color.decor_upcharge) {
                                                            //     order_item['color_fee'] += parseFloat(color.decor_upcharge.color_cost) + parseFloat(color.cost_cost);
                                                            // } else {
                                                            //     order_item['color_fee'] += parseFloat(color.cost_cost);
                                                            // }
                                                            order_item[
                                                                "color_fee"
                                                            ] += parseFloat(
                                                                color.total_decor_upcharge
                                                            );
                                                        }
                                                    );
                                                }
                                            }
                                        );
                                    }
                                    order_item["total_price"] =
                                        parseFloat(item.total_price) +
                                        parseFloat(item.discount) +
                                        order_item["color_fee"] +
                                        order_item["setup_fee"] +
                                        order_item["design_fee"] +
                                        order_item["non_standard_fees"] +
                                        order_item["name_number_fees"];

                                    subtotal += parseFloat(
                                        order_item.color_fee
                                    );
                                    order_items.push(order_item);
                                }
                                all_setup_fee = all_setup_fee + item_setup_fee;
                            }
                        });

                        // PRICE BREAKUPS
                        order_items.forEach((order_item) => {
                            order_item.base_price = 0;
                            order_item.markup_price = 0;
                            order_item.markup_percentage = 0;
                            order_item.ink_price = 0;
                            order_item.single_location_price = 0;
                            order_item.sizes.forEach((size) => {
                                order_item.base_price +=
                                    size.base_price * size.quantity;
                                order_item.ink_price +=
                                    parseFloat(size.ink_price) * size.quantity;
                                order_item.single_location_price = parseFloat(
                                    size.single_location_price
                                );
                                order_item.markup_price +=
                                    size.markup_price * size.quantity;
                                order_item.markup_percentage =
                                    size.markup_percentage;
                            });

                            // order_item.ink_price = parseFloat(order_item.ink_price) * parseInt(order_item.total_quantity);
                            order_item.single_location_price =
                                parseFloat(order_item.single_location_price) *
                                parseInt(order_item.total_quantity);
                        });

                        this.order_detail.items = order_items;
                        this.order_detail.total_setup_fee = all_setup_fee;
                        // Calculate subtotal from item_sub_total of all grouped order items
                        subtotal = 0;
                        let total_discount = 0;
                        order_items.forEach((order_item) => {
                            if (order_item.item_sub_total) {
                                subtotal += parseFloat(
                                    order_item.item_sub_total
                                );
                            } else {
                                // Fallback to old calculation if item_sub_total is not available
                                subtotal += parseFloat(
                                    order_item.total_price || 0
                                );
                            }
                            // Calculate total discount from all sizes in this item
                            if (
                                order_item.sizes &&
                                Array.isArray(order_item.sizes)
                            ) {
                                order_item.sizes.forEach((size) => {
                                    if (size.discount) {
                                        total_discount += parseFloat(
                                            size.discount || 0
                                        );
                                    }
                                });
                            } else if (order_item.total_discount) {
                                // Fallback: use total_discount if available
                                total_discount += parseFloat(
                                    order_item.total_discount || 0
                                );
                            }
                        });
                        // Subtract total discount from subtotal
                        this.order_detail.subtotal = subtotal - total_discount;

                        // Assign order_items to order_detail.items so template can access it
                        this.order_detail.items = order_items;

                        // total_non_standard_colors is a prop, don't set it in data
                        // this.total_non_standard_colors = [
                        //     ...new Set(total_non_standard_colors)
                        // ];
                        resolve(data);
                        this.isLoader = false;
                    })
                    .catch((response) => {
                        this.isLoader = false;
                    });
            });
        },

        openCostPopup() {
            $(function () {
                $(".cart_tbl_mobile").addClass("set-popup-size");
                $(document).on("click", function (e) {
                    if ($(e.target).is(".cart_tbl_mobile") === false) {
                        $(".cart_tbl_mobile").removeClass("set-popup-size");
                    }
                });
            });
        },
        showDesignImages(data) {
            if (data) {
                let json = this.safeParseJSON(data);
                if (json && Array.isArray(json)) {
                    json = json.filter(
                        (img) =>
                            img.canvas_images && img.canvas_images.length > 0
                    );
                    if (json.length > 0) {
                        return true;
                    }
                }
            }
            return false;
        },
        getArtworkPreviewFromDesignImages(design_images) {
            if (!design_images) return null;
            const parsed = this.safeParseJSON(design_images);
            if (!parsed || !Array.isArray(parsed) || parsed.length === 0) {
                return null;
            }
            // Try to get the first image from design_images
            const firstImage = parsed[0];
            // Check for design_image property first
            if (firstImage.design_image) {
                return firstImage.design_image;
            }
            // Check for url property
            if (firstImage.url) {
                return firstImage.url;
            }
            // Check for canvas_images
            if (
                firstImage.canvas_images &&
                firstImage.canvas_images.length > 0
            ) {
                return firstImage.canvas_images[0].image_path;
            }
            return null;
        },
        getDecorationMethodName(type) {
            let decoration_data = this.decorationMethods.find(
                (method) => method.id == type
            );
            if (decoration_data) {
                return decoration_data.name;
            }

            return "";
        },

        getDecoratorLogo(item) {
            if (!item) return "";
            const decorator = item.Decorator;
            if (decorator && decorator.logo_file) return decorator.logo_file;
            const vendor = item.Vendor;
            if (vendor && vendor.logo_file) return vendor.logo_file;
            return "";
        },

        getDecorationServiceName(item) {
            // Get ecomm_display from decoration JSON (saved at order time via master_service_id lookup)
            if (item.decoration) {
                let decoration = item.decoration;
                if (typeof decoration === "string") {
                    try {
                        decoration = JSON.parse(decoration);
                    } catch (e) {
                        decoration = null;
                    }
                }

                // Check ecomm_display directly from decoration object
                if (decoration && decoration.ecomm_display) {
                    return decoration.ecomm_display;
                }
                // Check master_service.ecomm_display (same as admin)
                if (
                    decoration.master_service &&
                    decoration.master_service.ecomm_display
                ) {
                    return decoration.master_service.ecomm_display;
                }
            }

            return "";
        },
        // Get estimated shipping date from item
        getEstimatedShippingDate(item) {
            // First check item directly
            if (item && item.estimated_shipping_date) {
                return item.estimated_shipping_date;
            }
            // If not found, check sizes array for parent = 1
            if (
                item &&
                item.sizes &&
                Array.isArray(item.sizes) &&
                item.sizes.length > 0
            ) {
                // Find the first size with parent = 1 (main item)
                const parentSize = item.sizes.find((size) => size.parent === 1);
                if (parentSize && parentSize.estimated_shipping_date) {
                    return parentSize.estimated_shipping_date;
                }
                // Fallback: use first size if no parent = 1 found
                if (item.sizes[0] && item.sizes[0].estimated_shipping_date) {
                    return item.sizes[0].estimated_shipping_date;
                }
            }
            return null;
        },
        // Format estimated shipping date for display
        formatEstimatedShippingDate(dateString) {
            if (!dateString) return "";
            try {
                const date = new Date(dateString);
                if (isNaN(date.getTime())) return dateString;
                const mm = String(date.getMonth() + 1).padStart(2, "0");
                const dd = String(date.getDate()).padStart(2, "0");
                const yyyy = date.getFullYear();
                return `${mm}/${dd}/${yyyy}`;
            } catch (e) {
                return dateString;
            }
        },

        with2Decimals(num) {
            var with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
            return parseFloat(with2Decimals);
        },

        hasLimit(item, index) {
            if (!item.is_color_show_more) {
                return index < this.colors_limit;
            }
            return true;
        },
        // Safe JSON parse - handles both strings and already parsed objects
        safeParseJSON(value) {
            if (!value) return null;
            if (typeof value === "string") {
                try {
                    return JSON.parse(value);
                } catch (e) {
                    return null;
                }
            }
            // Already an object/array
            return value;
        },
        // Parse breakdown JSON string
        parseBreakdown(breakdownString) {
            if (!breakdownString) return null;
            try {
                if (typeof breakdownString === "string") {
                    return JSON.parse(breakdownString);
                }
                return breakdownString;
            } catch (e) {
                return null;
            }
        },
        // Get Packaging Breakdown
        getPackagingBreakdown() {
            if (
                !this.order_detail ||
                !this.order_detail.packaging_kitting_handling_breakdown
            )
                return [];
            const breakdown = this.parseBreakdown(
                this.order_detail.packaging_kitting_handling_breakdown
            );
            if (!breakdown || !Array.isArray(breakdown)) return [];
            return breakdown;
        },
        // Get Packaging Total
        // Get total discount for an item (sum of all sizes' discounts)
        getItemTotalDiscount(item) {
            if (!item || !item.sizes || !Array.isArray(item.sizes)) {
                // Fallback: use total_discount if available
                return parseFloat(item.total_discount || 0);
            }
            let total = 0;
            item.sizes.forEach((size) => {
                if (size.discount) {
                    total += parseFloat(size.discount || 0);
                }
            });
            return parseFloat(total.toFixed(2));
        },
        getPackagingTotal() {
            const breakdown = this.getPackagingBreakdown();
            if (breakdown && breakdown.length > 0) {
                let total = 0;
                breakdown.forEach((item) => {
                    if (
                        item.total &&
                        item.total !== "INCL" &&
                        item.total !== "-"
                    ) {
                        total += parseFloat(item.total) || 0;
                    } else if (
                        (item.amt || item.amount) &&
                        item.amt !== "INCL" &&
                        item.amt !== "-" &&
                        item.amount !== "INCL" &&
                        item.amount !== "-"
                    ) {
                        total += parseFloat(item.amt || item.amount || 0);
                    }
                });
                if (total > 0) {
                    return parseFloat(total.toFixed(2));
                }
            }
            // Fallback to packaging_cost if breakdown is not available
            if (this.order_detail && this.order_detail.packaging_cost) {
                return parseFloat(this.order_detail.packaging_cost) || 0;
            }
            return 0;
        },
        // Get Shipping Breakdown
        getShippingBreakdown() {
            if (
                !this.order_detail ||
                !this.order_detail.shipping_cost_breakdown
            )
                return [];
            const breakdown = this.parseBreakdown(
                this.order_detail.shipping_cost_breakdown
            );
            if (!breakdown || !Array.isArray(breakdown)) return [];
            return breakdown;
        },
        // Get Shipping Total
        getShippingTotal() {
            const breakdown = this.getShippingBreakdown();
            if (!breakdown || breakdown.length === 0) {
                if (this.order_detail && this.order_detail.ship_cost) {
                    return parseFloat(this.order_detail.ship_cost) || 0;
                }
                return 0;
            }
            let total = 0;
            breakdown.forEach((item) => {
                if (item.total && item.total !== "INCL" && item.total !== "-") {
                    total += parseFloat(item.total) || 0;
                } else if (
                    (item.amt || item.amount) &&
                    item.amt !== "INCL" &&
                    item.amt !== "-" &&
                    item.amount !== "INCL" &&
                    item.amount !== "-"
                ) {
                    total += parseFloat(item.amt || item.amount || 0);
                }
            });
            return parseFloat(total.toFixed(2));
        },
        // Get Sales Tax Breakdown
        getSalesTaxBreakdown() {
            if (!this.order_detail || !this.order_detail.sales_tax_breakdown)
                return [];
            const breakdown = this.parseBreakdown(
                this.order_detail.sales_tax_breakdown
            );
            if (!breakdown || !Array.isArray(breakdown)) return [];
            return breakdown;
        },
        // Get Sales Tax Total
        getSalesTaxTotal() {
            const breakdown = this.getSalesTaxBreakdown();
            if (!breakdown || breakdown.length === 0) {
                if (this.order_detail && this.order_detail.sales_tax) {
                    return parseFloat(this.order_detail.sales_tax) || 0;
                }
                return 0;
            }
            let total = 0;
            breakdown.forEach((item) => {
                if (item.total && item.total !== "INCL" && item.total !== "-") {
                    total += parseFloat(item.total) || 0;
                } else if (
                    (item.amt || item.amount) &&
                    item.amt !== "INCL" &&
                    item.amt !== "-" &&
                    item.amount !== "INCL" &&
                    item.amount !== "-"
                ) {
                    total += parseFloat(item.amt || item.amount || 0);
                }
            });
            return parseFloat(total.toFixed(2));
        },
        // Get Grand Total
        getGrandTotal() {
            const subtotal = parseFloat(
                (this.order_detail && this.order_detail.subtotal) || 0
            );
            const packaging = this.getPackagingTotal();
            const shipping = this.getShippingTotal();
            const salesTax = this.getSalesTaxTotal();
            return parseFloat(
                (subtotal + packaging + shipping + salesTax).toFixed(2)
            );
        },
        // Price format helper
        icPriceFormat(price) {
            return new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2
            }).format(price);
        },
        // Get breakdown data from item (similar to admin OrderDetails)
        getBreakdownData(item, field) {
            // First check if data exists directly on item (already parsed)
            if (item[field] !== undefined && item[field] !== null) {
                // If it's already an array or object, return it
                if (
                    Array.isArray(item[field]) ||
                    typeof item[field] === "object"
                ) {
                    return item[field];
                }
                // If it's a string, try to parse it
                if (typeof item[field] === "string") {
                    try {
                        return JSON.parse(item[field]);
                    } catch (e) {
                        return null;
                    }
                }
                return item[field];
            }
            // If not found on item, check first size item
            if (
                item.sizes &&
                item.sizes.length > 0 &&
                item.sizes[0] &&
                item.sizes[0][field]
            ) {
                // If field is a string (JSON), parse it
                if (typeof item.sizes[0][field] === "string") {
                    try {
                        return JSON.parse(item.sizes[0][field]);
                    } catch (e) {
                        return null;
                    }
                }
                // If already parsed, return as is
                if (
                    Array.isArray(item.sizes[0][field]) ||
                    typeof item.sizes[0][field] === "object"
                ) {
                    return item.sizes[0][field];
                }
                return item.sizes[0][field];
            }
            return null;
        },
        // Calculate Base Fee Total from breakdown
        getBaseFeeTotal(item) {
            const baseFee = this.getBreakdownData(item, "base_fee");
            if (!baseFee || !Array.isArray(baseFee)) {
                return 0;
            }
            let total = 0;
            baseFee.forEach((fee) => {
                if (fee && fee.total) {
                    const feeTotal = parseFloat(fee.total);
                    if (!isNaN(feeTotal)) {
                        total += feeTotal;
                    }
                }
            });
            return total;
        },
        // Calculate Run Charge Total from breakdown
        getRunChargeTotal(item) {
            const runCharge = this.getBreakdownData(
                item,
                "run_charge_breakdown"
            );
            if (!runCharge || !Array.isArray(runCharge)) return 0;
            let total = 0;
            runCharge.forEach((breakdownItem) => {
                // Handle location-based items
                if (breakdownItem.items && Array.isArray(breakdownItem.items)) {
                    breakdownItem.items.forEach((item_data) => {
                        if (
                            item_data.type === "total" &&
                            item_data.total &&
                            item_data.total !== "INCL"
                        ) {
                            total += parseFloat(item_data.total) || 0;
                        } else if (
                            item_data.total &&
                            item_data.total !== "INCL" &&
                            !item_data.isIncluded
                        ) {
                            total += parseFloat(item_data.total) || 0;
                        }
                    });
                }
                // Handle otherService items (root level)
                if (
                    breakdownItem.type === "otherService" &&
                    breakdownItem.total &&
                    breakdownItem.total !== "INCL"
                ) {
                    total += parseFloat(breakdownItem.total) || 0;
                }
            });
            return total;
        },
        // Calculate Setup Fees Total from breakdown
        getSetupFeesTotal(item) {
            const setupFees = this.getBreakdownData(item, "setup_fees_details");
            if (!setupFees || typeof setupFees !== "object") return 0;
            let total = 0;
            if (setupFees.total) {
                total = parseFloat(setupFees.total) || 0;
            }
            return total;
        },
        // Get rush service name with delivery date (only for rush options)
        getRushServiceNameWithDate(service, item) {
            if (!service) {
                return `Service`;
            }

            const serviceName =
                service.ecomm_display ||
                service.name ||
                service.service_name ||
                `Service`;

            // Only show date for rush option services (is_rush_option === true)
            if (!service.is_rush_option) {
                return serviceName;
            }

            // Get estimated_shipping_date from item or first size (parent = 1)
            let estimatedShippingDate = null;

            // First check item directly
            if (item && item.estimated_shipping_date) {
                estimatedShippingDate = item.estimated_shipping_date;
            }
            // If not found, check first size item (parent = 1)
            else if (
                item &&
                item.sizes &&
                Array.isArray(item.sizes) &&
                item.sizes.length > 0
            ) {
                // Find the first size with parent = 1 (main item)
                const parentSize = item.sizes.find((size) => size.parent === 1);
                if (parentSize && parentSize.estimated_shipping_date) {
                    estimatedShippingDate = parentSize.estimated_shipping_date;
                }
                // Fallback: use first size if no parent = 1 found
                else if (
                    item.sizes[0] &&
                    item.sizes[0].estimated_shipping_date
                ) {
                    estimatedShippingDate =
                        item.sizes[0].estimated_shipping_date;
                }
            }

            // Format and return if date found
            if (estimatedShippingDate) {
                try {
                    const date = new Date(estimatedShippingDate);
                    if (!isNaN(date.getTime())) {
                        const mm = String(date.getMonth() + 1).padStart(2, "0");
                        const dd = String(date.getDate()).padStart(2, "0");
                        const yyyy = date.getFullYear();
                        const formattedDate = `${mm}/${dd}/${yyyy}`;
                        return `${serviceName} (${formattedDate})`;
                    }
                } catch (e) {
                    console.error(
                        "Error formatting estimated_shipping_date:",
                        e
                    );
                }
            }

            // Fallback: check service for formatted_delivery_date or delivery_date
            if (service.formatted_delivery_date) {
                return `${serviceName} (${service.formatted_delivery_date})`;
            }

            if (service.delivery_date) {
                try {
                    const date = new Date(service.delivery_date);
                    if (!isNaN(date.getTime())) {
                        const mm = String(date.getMonth() + 1).padStart(2, "0");
                        const dd = String(date.getDate()).padStart(2, "0");
                        const yyyy = date.getFullYear();
                        const formattedDate = `${mm}/${dd}/${yyyy}`;
                        return `${serviceName} (${formattedDate})`;
                    }
                } catch (e) {
                    console.error("Error formatting delivery_date:", e);
                }
            }

            // Return service name without date if no date available
            return serviceName;
        },
        // Calculate Custom Color Fee Total from breakdown
        getCustomColorFeeTotal(item) {
            const customColorFee = this.getBreakdownData(
                item,
                "custom_color_fee"
            );
            if (!customColorFee || !Array.isArray(customColorFee)) {
                return 0;
            }
            let total = 0;
            customColorFee.forEach((fee) => {
                if (fee && fee.total) {
                    const feeTotal = parseFloat(fee.total);
                    if (!isNaN(feeTotal)) {
                        total += feeTotal;
                    }
                }
            });
            return total;
        },
        // Calculate Rush Fee Total from breakdown
        getRushFeeTotal(item) {
            const rushFee = this.getBreakdownData(item, "rush_fee_breakdown");
            if (!rushFee) return 0;

            // First check if there's a total field at root level
            if (rushFee.total !== undefined && rushFee.total !== null) {
                const rootTotal = parseFloat(rushFee.total || 0);
                if (!isNaN(rootTotal) && rootTotal > 0) {
                    return rootTotal;
                }
            }

            // Otherwise calculate from services array
            if (!rushFee.services || !Array.isArray(rushFee.services)) {
                return 0;
            }
            let total = 0;
            rushFee.services.forEach((service) => {
                if (service) {
                    // Prefer service.total, then retail_cost
                    let servicePrice = 0;
                    if (service.total !== undefined && service.total !== null) {
                        servicePrice = parseFloat(service.total || 0);
                    } else if (
                        service.retail_cost !== undefined &&
                        service.retail_cost !== null
                    ) {
                        servicePrice = parseFloat(service.retail_cost || 0);
                    }
                    if (!isNaN(servicePrice) && servicePrice > 0) {
                        total += servicePrice;
                    }
                }
            });
            return total;
        },
        // Get base fee unit price for a specific size
        getBaseFeeUnitPrice(item, sizeName) {
            const baseFee = this.getBreakdownData(item, "base_fee");
            if (!baseFee || !Array.isArray(baseFee)) {
                return null;
            }
            // Find the fee item that matches the size
            const feeItem = baseFee.find((fee) => {
                if (fee && fee.name) {
                    // Use regex to match exact size at the end after " - " to avoid partial matches
                    // (e.g., "Product Base Price - S" should match "S" but not "XS")
                    // This ensures "S" doesn't match "XS", "2XS", etc.
                    const regex = new RegExp(
                        " - " +
                            sizeName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") +
                            "$"
                    );
                    return regex.test(fee.name);
                }
                return false;
            });
            if (feeItem && feeItem.amt) {
                return parseFloat(feeItem.amt) || null;
            }
            return null;
        },
        // Get base fee total for a specific size
        getBaseFeeTotalForSize(item, sizeName) {
            const baseFee = this.getBreakdownData(item, "base_fee");
            if (!baseFee || !Array.isArray(baseFee)) {
                return null;
            }
            // Find the fee item that matches the size
            const feeItem = baseFee.find((fee) => {
                if (fee && fee.name) {
                    // Use regex to match exact size at the end after " - " to avoid partial matches
                    // (e.g., "Product Base Price - S" should match "S" but not "XS")
                    // This ensures "S" doesn't match "XS", "2XS", etc.
                    const regex = new RegExp(
                        " - " +
                            sizeName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") +
                            "$"
                    );
                    return regex.test(fee.name);
                }
                return false;
            });
            if (feeItem && feeItem.total) {
                return parseFloat(feeItem.total) || null;
            }
            return null;
        },
        // Get size name from size object
        getSizeName(size) {
            if (size.MainNewSubProduct && size.MainNewSubProduct.Size) {
                return size.MainNewSubProduct.Size.size;
            } else if (size.NewSubProduct && size.NewSubProduct.Size) {
                return size.NewSubProduct.Size.size;
            } else if (size.size) {
                return size.size;
            }
            return "N/A";
        },
        // Get current tooltip for an item index
        getCostTooltip(itemIndex) {
            if (!this.costTooltipVisible) return null;
            // costTooltipVisible is in format "itemIndex-tooltipType"
            const parts = this.costTooltipVisible.split("-");
            if (parts.length >= 2 && parts[0] == itemIndex) {
                // Return the tooltip type (everything after the first dash)
                return parts.slice(1).join("-");
            }
            return null;
        },
        // Toggle tooltip for cost breakdown
        toggleCostTooltip(itemIndex, tooltipType) {
            const key = `${itemIndex}-${tooltipType}`;
            if (this.costTooltipVisible === key) {
                this.costTooltipVisible = null;
            } else {
                this.costTooltipVisible = key;
            }
        },
        closeCostTooltip(itemIndex) {
            // If itemIndex is provided, only close if it matches current tooltip
            if (itemIndex !== undefined) {
                const currentTooltip = this.getCostTooltip(itemIndex);
                if (currentTooltip) {
                    this.costTooltipVisible = null;
                }
            } else {
                // If no index provided, close any tooltip
                this.costTooltipVisible = null;
            }
        }
    }
};
</script>

<style>
.imprint-loc-extra-meta {
    margin-top: 8px;
    font-size: 13px;
    color: #333;
}
.imprint-loc-shipdate {
    font-size: 12px;
    color: #666;
    margin-top: 2px;
}
.order-details .total_price {
    max-width: 100%;
}
.contact_detail_wrap {
    background: #fff;
    padding-bottom: 12px;
    margin-top: 30px;
}
.base_product_total_box_custom span {
    margin: 0px !important;
    font-weight: 400;
}
/* ======== Order totals summary (admin-matching byaddress styles) ======== */
.order-details .byaddress-total-col {
    min-width: 0;
    overflow: visible;
}
.order-details .byaddress-fee-summary {
    border: 0 !important;
    border-radius: 0;
    padding: 8px 0 4px !important;
    background: transparent !important;
    font-family: "Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}
.order-details .byaddress-fee-summary .base_product_total_box_custom {
    border: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin: 0 !important;
    background: transparent !important;
}
.order-details .byaddress-total-row {
    flex-wrap: nowrap;
    align-items: center;
    padding: 8px 0;
    min-height: 22px;
}
.order-details .byaddress-total-row .total_p_custom {
    min-width: 0;
    flex: 1 1 auto;
}
.order-details .byaddress-fee-summary .byaddress-total-row:not(.byaddress-item-subtotal-row) .byaddress-label {
    color: #606060 !important;
    font-size: 16px !important;
    line-height: 16px !important;
    font-weight: 400 !important;
    white-space: nowrap;
    margin-right: 8px;
}
.order-details .byaddress-fee-summary .byaddress-total-row:not(.byaddress-item-subtotal-row) .byaddress-value {
    color: #121212 !important;
    font-size: 16px !important;
    line-height: 16px !important;
    font-weight: 400 !important;
    text-align: right;
}
.order-details .byaddress-item-subtotal-block {
    margin-top: 0;
    padding-top: 10px;
    border-top: 1px solid #BEBEBE4D;
}
.order-details .byaddress-item-subtotal-row .byaddress-label span,
.order-details .byaddress-item-subtotal-row .byaddress-value {
    color: #000000 !important;
    font-weight: 700 !important;
    font-size: 16px;
    line-height: 16px;
}
.order-details .byaddress-fee-summary .col-md-12 {
    padding: 0px 0px 12px 0px;
}
.order-details .byaddress-fee-summary .col-md-12.byaddress-item-subtotal-block {
    padding: 12px 0px 0px 0px;
}
.order-details .product_information .p_border .product-box {
    padding: 8px 6px 7px 14px;
    border: solid 1px #d7d5d5;
    background-color: #f8f8f8;
    width: 122px;
    margin-right: 20px;
}
.order-details .product_information .p_border .product-box img {
    width: 120px;
    height: 99px;
    object-fit: contain;
}
/* ======== Admin-matching layout fixes ======== */
.order-details .base_pro_row_custom {
    border: 1px solid #BEBEBE66;
    margin-top: 16px !important;
    padding: 0px 16px;
}
.order-details .acc__panel {
    padding: 0px 32px;
}
.order-details .order-list-col {
    padding-right: 0px;
    padding-left: 0px;
}
.order-details .order-list-col-sec-last {
    border-left: 1px solid #BEBEBE4D;
    padding-left: 16px !important;
    padding-right: 0px !important;
}
/* Product image box — constrained to admin size in order items area
   Using 5-class specificity to beat the .product_information .p_border rule (4 classes) */
.order-details .product_information .base_pro_row_custom .order-list-col .product-box {
    padding: 0 !important;
    border: 1px solid #d3d3d3 !important;
    background-color: #f8f8f8 !important;
    width: 90px !important;
    height: 90px !important;
    margin-right: 16px !important;
    overflow: hidden;
    flex-shrink: 0;
}
.order-details .product_information .base_pro_row_custom .order-list-col .product-box img {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain !important;
    max-width: none !important;
}
.order-details .product_information .base_pro_row_custom .product_number {
    border: 1px solid #D3D3D3;
    background-color: #F4F4F4;
    display: block;
    text-align: center;
    font-size: 12px;
    padding: 2px 4px;
    margin-top: 4px;
    width: 90px;
}
.order-details .product_details_box {
    padding-bottom: 12px;
    justify-content: space-between;
}
.order-details .vendor_name {
    color: #5E5D5D;
    line-height: 14px;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 8px;
}
.order-details .product_name_main {
    color: #121212;
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
}
.order-details .order-item-total-qty {
    margin-top: 6px;
    line-height: 18px;
}
.order-details .table-btn-col {
    flex-direction: column-reverse;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 20px;
}
.order-details .order-list-page .order-list-col .data-export-btn .export-btn {
    margin-top: 20px;
    padding: 8px;
    font-size: 14px;
}
.order-details .name-number-data {
    margin-top: 0px;
}
/* Decorator logo */
.imprint-loc-decorator-logo {
    margin-bottom: 2px;
}
.order-details .brand-logo-img,
.brand-logo-img {
    max-width: 120px;
    max-height: 50px;
    object-fit: contain;
    display: inline-block;
}
.order-details .product_information .p_border {
    padding-top: 12px !important;
    border-top: 1px dashed #BEBEBE66;
}
.p_border .product_details {
    padding: 0px;
}
.product_details{
padding: 10px 0px;
}
.pl-1 {
    padding-left: 1rem !important;
}
.contact_detail_wrap {
    margin-top: 0px;
}

.order-details-section {
    padding: 20px 0px;
}
.product-box .hover_search img {
    border: none !important;
    width: 15px !important;
    height: 25px !important;
    display: flex;
    justify-content: center;
    padding: 0px !important;
}
.product-box {
    position: relative;
}
.product-box .hover_search {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 8px;
    margin: auto;
    width: 35px;
    height: 35px !important;
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f2790c;
    opacity: 0;
}
.product-box:hover .hover_search {
    opacity: 1;
}

.order-details
    .product_information
    .base_product_box_custom
    .dropdown
    .dropdown-toggle
    img {
    width: 16px;
    height: 16px;
    max-width: 16px;
}
.modal .modal-dialog .modal-header {
    padding: 12px 46px !important;
}
.modal .modal-dialog .modal-header .close {
    padding: 0px 4px 0px 0px !important;
}
.modal .modal-dialog .modal-body {
    padding: 40px 46px;
}
.cart_modal_s .canvas_auto_preview_images.new_canvas_images2 .product-box img {
    max-height: 450px !important;
}
/* Match admin: compact 4-panel layout (Front, Back, Left, Right) */
.cart_modal_s .canvas_auto_preview_images .preview-image {
    display: inline-block !important;
    width: 23% !important;
    padding: 6px !important;
    border: 1px solid #000;
    margin: 0 6px 6px 6px !important;
    min-height: 280px;
    vertical-align: top;
}
.cart_modal_s .canvas_auto_preview_images .preview-image h4:not(.dimension_text) {
    font-size: 16px;
    font-weight: bold;
    line-height: 1.2;
    color: #000;
    text-align: center;
    margin: 2px 0 4px 0 !important;
}
.cart_modal_s .canvas_auto_preview_images .preview-image .product-box {
    text-align: center;
    margin: 2px 0 0 0 !important;
}
.cart_modal_s .canvas_auto_preview_images .preview-image .product-box img {
    max-height: 280px !important;
    max-width: 280px !important;
    width: auto;
    object-fit: contain;
}
.cart_modal_s .canvas_auto_preview_images .preview-image .dimension_text {
    font-size: 16px;
    margin: 2px 0 2px 0 !important;
    line-height: 1.3;
}
.cart_modal_s .canvas_auto_preview_images .preview-image .product_details.mb-2 {
    margin-top: 7px !important;
}
.cart_modal_s .canvas_auto_preview_images .preview-image .product_details.mb-2 p {
    font-size: 13px;
    margin-bottom: 2px !important;
}

.cart_modal_s .canvas_auto_preview_images.new_canvas_images2 .preview-image {
    width: 48% !important;
    margin: 8px !important;
    min-height: 450px;
}
.cart_modal_s .canvas_auto_preview_images.new_canvas_images2 {
    display: flex !important;
    justify-content: center;
    align-items: center;
}
.cart_modal_s .canvas_auto_preview_images {
    overflow-x: auto;
    overflow-y: hidden;
    max-height: 75vh;
    margin-top: 12px !important;
    display: flex !important;
    flex-wrap: nowrap;
    justify-content: flex-start;
}

.standard_colors .dropdown .dropdown-toggle img {
    min-width: 16px;
    width: 20px;
    height: 20px;
}
.small_color_box {
    width: 10px;
    height: 10px;
    display: inline-block;
    margin-right: 8px;
    background: #000;
}
.cart_modal_s .canvas_auto_preview_images.new_canvas_images1 .preview-image {
    width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
    border: none;
    min-height: auto !important;
}
.cart_modal_s
    .canvas_auto_preview_images.new_canvas_images1
    .preview-image
    .product-box
    img {
    max-height: 430px !important;
}
.cart_preview .modal-content .preview-image img,
video {
    max-height: 500px;
    -o-object-fit: contain;
    object-fit: contain;
    margin-top: 60px;
    width: auto;
}
.cart_modal_s-img {
    max-width: 1400px !important;
}
.cart_modal_s-img .cart_popup_title {
    font-size: 20px;
    color: #000;
    font-weight: bold;
    line-height: 18px;
    padding-left: 15px;
}
.cart_modal_s-img .product_details-cart {
    margin: 0px !important;
    padding: 10px 10px 10px 0px !important;
    max-width: 224px;
    max-height: 303px;
    height: 100%;
    min-height: 194px;
}
.cart_modal_s-img .product_details-cart .choice_img {
    border: 1px solid black;
    padding: 0;
    min-height: 185px;
    display: flex;
    align-items: baseline;
    justify-content: center;
}
.cart_modal_s-img .order_shape_title {
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.7294117647);
    background-color: #ececec;
    width: 90%;
    text-transform: capitalize;
    padding: 4px;
    line-height: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    position: absolute;
    bottom: 10px;
}
.cart_modal_s-img .dimension_text {
    position: absolute;
    right: 11px;
    font-size: 15px;
    font-weight: 600;
    background-color: #ececec;
    width: 90%;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
}
.modal .cart_modal_s-img .modal-header {
    padding: 12px 46px !important;
    background-color: #fff !important;
    border: none;
}
.cart_modal_s-img .modal-scroll {
    max-height: 620px;
    overflow: auto;
    padding: 20px !important;
}
.cart_modal_s-img .modal-scroll .image-align-col {
    display: flex;
    width: 100%;
    vertical-align: top;
    padding: 0px;
    margin: 0px;
}

.modal .cart_modal_s-img .modal-header .close {
    padding: 18px 4px 0px 0px !important;
}
.images-popup-btn {
    font-size: 15px;
    letter-spacing: 1.73px;
    text-align: center;
    color: #0079c1 !important;
    padding: 16px 26px;
    min-width: 100px !important;
    border-color: #0079c1 !important;
    text-transform: uppercase;
    background: #ffffff;
    margin-top: 10px;
    margin-right: 10px;
}
.modal .cart_modal_s-img .product_details-cart .choice_img img {
    width: 100%;
    height: auto;
    max-height: 150px;
    padding: 5px;
    max-width: 100%;
}
.table {
    width: 100%;
}
@media screen and (max-width: 992px) {
    .cart_modal_s .canvas_auto_preview_images .preview-image {
        width: 46% !important;
        min-height: 300px !important;
    }
}
@media screen and (max-width: 768px) {
    .cart_modal_s
        .canvas_auto_preview_images.new_canvas_images2
        .preview-image {
        width: 98% !important;
    }
    .cart_modal_s .canvas_auto_preview_images .preview-image {
        width: 100% !important;
        margin: 5px 0 0 0 !important;
        min-height: 280px !important;
    }
    .modal .modal-dialog .modal-body {
        padding: 20px;
    }
    .modal .modal-dialog .modal-header {
        padding: 12px 20px !important;
    }
    .cart_modal_s .canvas_auto_preview_images.new_canvas_images2 {
        display: block !important;
    }
}
.tooltip-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
}
.info-icon-svg {
    width: 16px !important;
    height: 16px !important;
    max-width: 16px !important;
    max-height: 16px !important;
    color: #888;
    transition: color 0.2s;
    flex-shrink: 0;
    display: inline-block;
    vertical-align: middle;
}
.tooltip-wrapper:hover .info-icon-svg {
    color: #333;
}
.tooltip-content {
    visibility: hidden;
    position: absolute;
    top: 100%;
    left: 0;
    transform: translateX(0);
    background: #fff;
    color: #000;
    padding: 0px;
    border-radius: 6px;
    z-index: 9999;
    min-width: 392px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    margin-top: 8px;
    border: 1px solid #ddd;
    opacity: 0;
    transition: opacity 0.3s;
    white-space: normal;
    font-size: 14px;
}
.tooltip-content.is-visible {
    visibility: visible;
    opacity: 1;
}
.tooltip-header {
    padding: 9px 16px;
    background: hsla(204, 63%, 94%, 1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
}
.tooltip-header h4 {
    font-weight: 600;
    font-size: 14px;
    line-height: 14px;
    color: hsla(209, 72%, 41%, 1);
    margin-bottom: 0px;
}
.tooltip-header .close-icon {
    width: 18px;
    height: 18px;
    cursor: pointer;
    color: #666;
    flex-shrink: 0;
    transition: color 0.2s ease;
    padding: 4px;
    margin: -4px;
    box-sizing: content-box;
    display: block;
}
.tooltip-header .close-icon:hover {
    color: #333;
}
.tooltip-body {
    white-space: normal;
    padding: 16px;
    max-height: 180px;
    overflow-y: auto;
}
.base-fee-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 10px;
    font-size: 12px;
}
.base-fee-table thead {
    background-color: #f5f5f5;
}
.base-fee-table th {
    padding: 8px;
    text-align: left;
    font-weight: 600;
    color: #333;
    border-bottom: 1px solid #ddd;
    font-size: 12px;
    line-height: 1.4;
}
.base-fee-table th:nth-child(3),
.base-fee-table th:nth-child(4),
.base-fee-table th:nth-child(5) {
    text-align: right;
}
.base-fee-table td {
    padding: 8px;
    text-align: left;
    border-bottom: 1px solid #eee;
    font-weight: normal;
    font-size: 12px;
    color: #333;
    line-height: 1.4;
}
.base-fee-table td:nth-child(3),
.base-fee-table td:nth-child(4),
.base-fee-table td:nth-child(5) {
    text-align: right;
}
.base-fee-table tbody tr {
    border-bottom: 1px solid #eee;
}
.base-fee-table tbody tr.disable_data {
    color: #666;
}
.base-fee-table tbody tr.disable_data td {
    color: #666;
    font-weight: normal;
}
.base-fee-table tbody tr.total-row {
    border-top: 2px solid #ddd;
    border-bottom: none !important;
    background-color: #f5f5f5 !important;
    font-weight: bold;
}
.base-fee-table tbody tr.total-row td {
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: none !important;
}
.color-box-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
}
.color-box {
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    border: 1px solid #ddd;
    border-radius: 3px;
    cursor: pointer;
    display: inline-block;
    background-color: #ccc;
}
.color-box-img {
    width: 20px;
    height: 20px;
    border-radius: 3px;
    object-fit: cover;
}
.color-box:hover {
    border-color: #333;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.item-subtotal-row {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #e0e0e0;
}
.item-subtotal-row .col-md-6,
.item-subtotal-row .col-md-5 {
    font-weight: 600;
    color: #212121;
}
.product_details .price_right {
    text-align: right;
    color: #000;
    display: block;
}
.product_details .color-line {
    margin-bottom: 5px;
}
.item-subtotal-row .col-md-5 {
    font-weight: 700;
    font-size: 16px;
    text-align: right;
}
.total-row .text_right {
    text-align: right !important;
}
.total-row .text_left {
    text-align: left !important;
}
.comment_block {
    margin-top: 20px;
}
.comment_block h5 {
    font-weight: 700;
}
.decoration-service {
    font-size: smaller;
}
.discount_value {
    color: red !important;
}
.order-item-size-pricing__line {
    line-height: 2;
}
.order-details .order-item-total-qty{
    margin-top: 6px;
    line-height: 18px;
}
</style>
 
   
